// AcademicProgramsSections/ScienceAcademicPrograms.js
import React, { useMemo, useState } from "react";
import React2, { useState as useState2 } from "react";
import React3, { useMemo as useMemo2, useState as useState3 } from "react";
import React4, { useState as useState4 } from "react";
import React5, { useState as useState5 } from "react";
import React6, { useState as useState6 } from "react";
import React7, { useState as useState7 } from "react";
import React8, { useState as useState8 } from "react";
import React9, { useMemo as useMemo3, useState as useState9 } from "react";
import React10, { useState as useState10 } from "react";
import React11, { useState as useState11 } from "react";
import React12, { useState as useState12 } from "react";
import React13, { useState as useState13 } from "react";
import React14, { useMemo as useMemo4, useState as useState14 } from "react";
import React15, { useMemo as useMemo5, useState as useState15 } from "react";
import React16, { useMemo as useMemo6, useState as useState16 } from "react";
import React17, { useMemo as useMemo7, useState as useState17 } from "react";
import React18, { useMemo as useMemo8, useState as useState18 } from "react";
import React19 from "react";


// AcademicProgramsSections/programUtils.js
var cleanText = (value = "") => value.replace(/<[^>]*>/g, " ").replace(/&amp;/g, "&").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();
var getCourses = (courses, school) => courses || school?.courses || [];
var getLevels = (programmes) => [
  "All",
  ...new Set(programmes.map((item) => item.level).filter(Boolean))
];
var shortLevel = (level = "Programme") => {
  const labels = {
    Undergraduate: "UG",
    Postgraduate: "PG",
    Doctorate: "Ph.D.",
    Diploma: "Diploma",
    Certificate: "Certificate",
    "Post Graduate Diploma": "PG Diploma"
  };
  return labels[level] || level;
};
var programmeHref = (programme, basePath = "/programmes") => `${basePath}/${programme.name || "programme"}`;
function ArrowIcon({ className = "h-5 w-5" }) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className} aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-5-5 5 5-5 5" />
  </svg>;
}
function SearchIcon({ className = "h-5 w-5" }) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className} aria-hidden="true">
    <circle cx="11" cy="11" r="7" />
    <path strokeLinecap="round" d="m20 20-4-4" />
  </svg>;
}
function SectionIntro({ eyebrow, title, accent, description, dark = false, align = "left" }) {
  return <header className={`${align === "center" ? "mx-auto text-center" : ""} max-w-3xl`}>
    <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
      <span className={`h-px w-12 ${dark ? "bg-[#D5AD57]" : "bg-[#8B1E3F]"}`} />
      <span className={`text-sm font-bold uppercase tracking-[0.16em] ${dark ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}>{eyebrow}</span>
    </div>
    <h2 className={`mt-6 text-[clamp(40px,5vw,68px)] font-normal leading-[1.04] tracking-[-0.035em] ${dark ? "text-white" : "text-[#071A2F]"}`} style={{ fontFamily: '"Libre Caslon Display", Georgia, serif' }}>
      {title} <em className={`font-normal ${dark ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}>{accent}</em>
    </h2>
    <p className={`mt-6 text-base leading-8 sm:text-lg ${dark ? "text-white/65" : "text-[#132337]/65"}`}>{description}</p>
  </header>;
}

// AcademicProgramsSections/ScienceAcademicPrograms.js
function ScienceAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const levels = useMemo(() => getLevels(programmes), [programmes]);
  const [level, setLevel] = useState("All");
  const [selected, setSelected] = useState(0);
  const visible = level === "All" ? programmes : programmes.filter((item) => item.level === level);
  const featured = visible[Math.min(selected, Math.max(visible.length - 1, 0))];
  return <section className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-32" aria-labelledby="science-programmes">
    <div className="absolute inset-0 opacity-40 [background-image:radial-gradient(#071A2F_1px,transparent_1px)] [background-size:28px_28px] [mask-image:linear-gradient(to_bottom,black,transparent)]" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <SectionIntro eyebrow="Scientific pathways" title="Explore, test and" accent="discover." description="Choose a programme built around scientific enquiry, laboratory practice and research-led learning." />

      <div className="mt-12 flex flex-wrap gap-3" role="tablist" aria-label="Filter science programmes">
        {levels.map((item) => <button key={item} type="button" onClick={() => {
          setLevel(item);
          setSelected(0);
        }} className={`rounded-full border px-5 py-3 text-sm font-semibold transition ${level === item ? "border-[#071A2F] bg-[#071A2F] text-white" : "border-[#071A2F]/15 bg-white text-[#071A2F] hover:border-[#8B1E3F]"}`}>{item}</button>)}
      </div>

      {featured ? <div className="mt-9 grid overflow-hidden rounded-[32px] border border-[#071A2F]/10 bg-white shadow-[0_24px_70px_rgba(7,26,47,0.1)] lg:grid-cols-[0.72fr_1.28fr]">
        <div className="relative bg-[#071A2F] p-7 text-white sm:p-9 max-h-[550px] overflow-x-auto custom-scroll">
          <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#D5AD57]">Laboratory index</span>
          <div className="mt-7 space-y-3">
            {visible.map((item, index) => <button key={item.name || item.title} type="button" onClick={() => setSelected(index)} className={`group flex w-full items-center gap-4 rounded-2xl border p-4 text-left transition ${selected === index ? "border-[#D5AD57]/60 bg-white/10" : "border-white/10 hover:bg-white/[0.06]"}`}>
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-sm font-bold ${selected === index ? "bg-[#D5AD57] text-[#071A2F]" : "bg-white/10 text-white/65"}`}>{String(index + 1).padStart(2, "0")}</span>
              <span className="min-w-0"><small className="block text-xs font-bold uppercase tracking-wider text-[#D5AD57]">{shortLevel(item.level)}</small><strong className="mt-1 block truncate text-base">{item.title}</strong></span>
            </button>)}
          </div>
        </div>

        <article className="relative flex min-h-[520px] flex-col p-7 sm:p-10 lg:p-12">
          <div className="absolute right-8 top-7 flex h-24 w-24 items-center justify-center rounded-full border border-[#8B1E3F]/20 before:absolute before:h-14 before:w-14 before:rounded-full before:border before:border-[#D5AD57] after:absolute after:h-2 after:w-2 after:rounded-full after:bg-[#8B1E3F]" aria-hidden="true" />
          <span className="w-fit rounded-full bg-[#8B1E3F]/10 px-4 py-2 text-sm font-bold text-[#8B1E3F]">Current specimen · {shortLevel(featured.level)}</span>
          <h3 className="mt-10 max-w-2xl text-3xl font-semibold leading-tight text-[#071A2F] sm:text-4xl">{featured.title}</h3>
          <p className="mt-6 max-w-2xl text-base leading-8 text-[#132337]/65 sm:text-lg">{cleanText(featured.banner_description) || "Build strong disciplinary knowledge through practical investigation, modern laboratories and guided research."}</p>
          <div className="mt-auto grid gap-4 border-t border-[#071A2F]/10 pt-7 sm:grid-cols-3">
            {[["Duration", featured.duration], ["Learning cycle", featured.mode], ["Entry route", featured.eligibility]].map(([label, value]) => <div key={label}><span className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">{label}</span><strong className="mt-2 block text-base leading-6 text-[#071A2F]">{value || "See details"}</strong></div>)}
          </div>
          <a href={programmeHref(featured, basePath)} className="mt-8 inline-flex w-fit items-center gap-3 rounded-full bg-[#8B1E3F] px-6 py-3.5 text-base font-bold text-white transition hover:-translate-y-1 hover:bg-[#701832]">Examine programme <ArrowIcon /></a>
        </article>
      </div> : <p className="mt-12 rounded-2xl border border-[#071A2F]/10 bg-white p-8 text-base text-[#132337]/65">Programme information will be available soon.</p>}
    </div>
  </section>;
}

// AcademicProgramsSections/ArtsHumanitiesAcademicPrograms.js
function ArtsHumanitiesAcademicPrograms({
  courses,
  school,
  basePath = "/programmes",
}) {
  const programmes = getCourses(courses, school);

  const levels = useMemo2(
    () => getLevels(programmes),
    [programmes]
  );

  const [level, setLevel] = useState2("All");
  const [active, setActive] = useState2(0);

  const visible =
    level === "All"
      ? programmes
      : programmes.filter(
        (programme) => programme.level === level
      );

  const current =
    visible[Math.min(active, Math.max(visible.length - 1, 0))];

  const handleLevelChange = (selectedLevel) => {
    setLevel(selectedLevel);
    setActive(0);
  };

  return (
    <section
      id="arts-humanities-programmes"
      className="relative overflow-hidden bg-white py-20 sm:py-24 lg:py-28"
      aria-labelledby="arts-programmes-heading"
    >
      {/* Editorial background */}
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
      >
        <div className="absolute left-[5%] top-0 h-full w-px bg-[#8B1E3F]/10" />

        <div className="absolute right-[5%] top-0 h-full w-px bg-[#D5AD57]/20" />

        <div className="absolute -left-32 bottom-20 h-96 w-96 rounded-full bg-[#8B1E3F]/[0.04] blur-[90px]" />

        <div className="absolute right-0 top-24 font-['Libre_Caslon_Display',Georgia,serif] text-[260px] leading-none text-[#071A2F]/[0.018]">
          Aa
        </div>
      </div>

      <div className="relative mx-auto max-w-[1380px] px-5 sm:px-8 lg:px-10">
        {/* Editorial heading */}
        <div className="grid gap-10 border-b-2 border-[#071A2F] pb-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-end">
          <div>
            <div className="flex items-center gap-4">
              <span className="h-px w-12 bg-[#8B1E3F]" />

              <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                The academic anthology
              </span>
            </div>

            <h2
              id="arts-programmes-heading"
              className="mt-6 max-w-4xl text-[clamp(42px,5.5vw,74px)] font-normal leading-[1.02] tracking-[-0.04em] text-[#071A2F]"
              style={{
                fontFamily:
                  '"Libre Caslon Display", Georgia, serif',
              }}
            >
              Read the world.
              <em className="block font-normal text-[#8B1E3F]">
                Shape your perspective.
              </em>
            </h2>
          </div>

          <div>
            <p className="max-w-xl text-base leading-8 text-[#132337]/65 sm:text-lg">
              Explore programmes in language, literature, culture,
              society and human thought—curated as connected chapters
              in a broader intellectual journey.
            </p>

            <div className="mt-7 flex items-center gap-8">
              <div>
                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-4xl font-normal text-[#8B1E3F]">
                  {programmes.length}
                </strong>

                <span className="ml-3 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F]/50">
                  Chapters
                </span>
              </div>

              <div className="h-10 w-px bg-[#071A2F]/15" />

              <div>
                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-4xl font-normal text-[#A77B2D]">
                  {Math.max(levels.length - 1, 1)}
                </strong>

                <span className="ml-3 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F]/50">
                  Levels
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Academic levels */}
        <div className="mt-8 flex gap-2 overflow-x-auto">
          {levels.map((item) => {
            const isActive = level === item;

            const count =
              item === "All"
                ? programmes.length
                : programmes.filter(
                  (programme) => programme.level === item
                ).length;

            return (
              <button
                key={item}
                type="button"
                onClick={() => handleLevelChange(item)}
                className={`flex shrink-0 items-center gap-3 border-b-2 px-5 py-4 text-sm font-bold transition duration-300 ${isActive
                  ? "border-[#8B1E3F] bg-[#F4E8EC] text-[#8B1E3F]"
                  : "border-transparent text-[#071A2F]/60 hover:border-[#D5AD57] hover:text-[#071A2F]"
                  }`}
              >
                {item}

                <span
                  className={`flex h-7 min-w-7 items-center justify-center rounded-full px-2 ${isActive
                    ? "bg-[#8B1E3F] text-white"
                    : "bg-[#F7F2E8] text-[#071A2F]"
                    }`}
                >
                  {count}
                </span>
              </button>
            );
          })}
        </div>

        {current ? (
          <div className="mt-10 grid gap-6 lg:grid-cols-[0.78fr_1.22fr]">
            {/* Programme anthology */}
            <div className="border-y border-[#071A2F]/15">
              <div className="flex items-end justify-between border-b border-[#071A2F]/15 py-5">
                <div>
                  <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                    Programme anthology
                  </span>

                  <h3
                    className="mt-2 text-2xl font-normal text-[#071A2F]"
                    style={{
                      fontFamily:
                        '"Libre Caslon Display", Georgia, serif',
                    }}
                  >
                    Select a chapter.
                  </h3>
                </div>

                <span className="text-sm font-semibold text-[#132337]/50">
                  {visible.length} available
                </span>
              </div>

              <div className="max-h-[610px] divide-y divide-[#071A2F]/10 overflow-y-auto">
                {visible.map((programme, index) => {
                  const programmeId =
                    programme.name || programme.title;

                  const currentId =
                    current.name || current.title;

                  const isSelected = programmeId === currentId;

                  return (
                    <button
                      key={programmeId || index}
                      type="button"
                      onClick={() => setActive(index)}
                      className={`group grid w-full gap-4 px-4 py-5 text-left transition duration-300 sm:grid-cols-[58px_1fr_auto] sm:items-center ${isSelected
                        ? "bg-[#8B1E3F] text-white"
                        : "hover:bg-[#F7F2E8]"
                        }`}
                    >
                      <span
                        className={`font-['Libre_Caslon_Display',Georgia,serif] text-3xl italic ${isSelected
                          ? "text-[#D5AD57]"
                          : "text-[#A77B2D]"
                          }`}
                      >
                        {String(index + 1).padStart(2, "0")}
                      </span>

                      <span>
                        <span
                          className={`text-sm font-bold uppercase tracking-[0.1em] ${isSelected
                            ? "text-[#D5AD57]"
                            : "text-[#8B1E3F]"
                            }`}
                        >
                          {shortLevel(programme.level)}
                        </span>

                        <strong
                          className={`mt-2 line-clamp-2 block text-lg leading-7 ${isSelected
                            ? "text-white"
                            : "text-[#071A2F]"
                            }`}
                        >
                          {programme.title}
                        </strong>
                      </span>

                      <span
                        className={`grid h-11 w-11 place-items-center rounded-full border transition ${isSelected
                          ? "border-white/20 text-[#D5AD57]"
                          : "border-[#071A2F]/15 text-[#071A2F] group-hover:bg-[#071A2F] group-hover:text-white"
                          }`}
                      >
                        <ArrowIcon className="h-4 w-4" />
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Selected programme */}
            <article className="relative flex min-h-[680px] flex-col overflow-hidden bg-[#F7F2E8] p-7 sm:p-10 lg:p-12">
              <span className="pointer-events-none absolute -right-2 -top-10 font-['Libre_Caslon_Display',Georgia,serif] text-[220px] leading-none text-[#8B1E3F]/[0.055]">
                “
              </span>

              <div className="relative">
                <div className="flex flex-wrap items-center justify-between gap-5">
                  <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                    Selected chapter ·{" "}
                    {String(active + 1).padStart(2, "0")}
                  </span>

                  <span className="rounded-full border border-[#071A2F]/15 bg-white px-4 py-2 text-sm font-semibold text-[#071A2F]">
                    {shortLevel(current.level)}
                  </span>
                </div>

                <h3
                  className="mt-10 max-w-4xl text-[clamp(36px,4.5vw,58px)] font-normal leading-[1.08] text-[#071A2F]"
                  style={{
                    fontFamily:
                      '"Libre Caslon Display", Georgia, serif',
                  }}
                >
                  {current.title}
                </h3>

                <p className="mt-7 max-w-4xl text-base leading-8 text-[#132337]/65 sm:text-lg">
                  {cleanText(current.banner_description) ||
                    "Develop interpretation, cultural awareness, research depth and confident expression through disciplined academic study."}
                </p>
              </div>

              <div className="relative mt-10 grid border-y border-[#071A2F]/15 sm:grid-cols-3">
                {[
                  ["Academic level", shortLevel(current.level)],
                  ["Study period", current.duration],
                  ["Study mode", current.mode || "Full Time"],
                ].map(([label, value], index) => (
                  <div
                    key={label}
                    className={`py-6 sm:px-6 ${index < 2
                      ? "border-b border-[#071A2F]/10 sm:border-b-0 sm:border-r"
                      : ""
                      }`}
                  >
                    <span className="text-sm font-bold uppercase tracking-[0.1em] text-[#8B1E3F]">
                      {label}
                    </span>

                    <strong className="mt-3 block text-base leading-7 text-[#071A2F]">
                      {value || "View programme"}
                    </strong>
                  </div>
                ))}
              </div>

              {current.eligibility && (
                <div className="relative mt-7 border-l-4 border-[#D5AD57] bg-white p-6">
                  <span className="text-sm font-bold uppercase tracking-[0.11em] text-[#8B1E3F]">
                    Entry requirement
                  </span>

                  <p className="mt-3 text-sm leading-7 text-[#132337]/65">
                    {current.eligibility}
                  </p>
                </div>
              )}

              <div className="relative mt-auto pt-10">
                <a
                  href={programmeHref(current, basePath)}
                  className="inline-flex items-center gap-3 rounded-full bg-[#8B1E3F] px-7 py-4 text-base font-bold text-white transition duration-300 hover:-translate-y-1 hover:bg-[#071A2F]"
                >
                  Continue to programme
                  <ArrowIcon />
                </a>
              </div>
            </article>
          </div>
        ) : (
          <div className="mt-10 flex min-h-[320px] items-center justify-center bg-[#F7F2E8] p-8 text-center">
            <div>
              <span className="font-['Libre_Caslon_Display',Georgia,serif] text-7xl text-[#8B1E3F]/30">
                “
              </span>

              <h3 className="mt-4 text-3xl font-semibold text-[#071A2F]">
                No programmes found
              </h3>

              <p className="mt-3 text-sm leading-7 text-[#132337]/55">
                Select another academic level to continue exploring.
              </p>

              <button
                type="button"
                onClick={() => handleLevelChange("All")}
                className="mt-6 rounded-full bg-[#8B1E3F] px-7 py-3.5 text-sm font-bold text-white"
              >
                View all programmes
              </button>
            </div>
          </div>
        )}

        {/* Humanities learning spectrum */}
        <div className="mt-12 grid border-y border-[#071A2F]/15 sm:grid-cols-2 lg:grid-cols-4">
          {[
            ["Interpret", "Texts, language and cultural contexts"],
            ["Question", "Ideas, histories and social assumptions"],
            ["Research", "Human experience with academic rigour"],
            ["Express", "Original perspectives with confidence"],
          ].map(([title, description], index) => (
            <div
              key={title}
              className={`py-7 sm:px-6 ${index < 3
                ? "border-b border-[#071A2F]/10 lg:border-b-0 lg:border-r"
                : ""
                }`}
            >
              <span className="font-['Libre_Caslon_Display',Georgia,serif] text-3xl text-[#A77B2D]">
                0{index + 1}
              </span>

              <h3 className="mt-4 text-xl font-semibold text-[#071A2F]">
                {title}
              </h3>

              <p className="mt-3 text-sm leading-7 text-[#132337]/60">
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// AcademicProgramsSections/LawAcademicPrograms.js
function LawAcademicPrograms({
  courses,
  school,
  basePath = "/programmes",
}) {
  const programmes = getCourses(courses, school);

  const levels = useMemo2(
    () => getLevels(programmes),
    [programmes]
  );

  const [level, setLevel] = useState3("All");
  const [active, setActive] = useState3(0);

  const visible =
    level === "All"
      ? programmes
      : programmes.filter(
        (programme) => programme.level === level
      );

  const current =
    visible[Math.min(active, Math.max(visible.length - 1, 0))];

  const handleLevelChange = (selectedLevel) => {
    setLevel(selectedLevel);
    setActive(0);
  };

  return (
    <section
      id="law-academic-programmes"
      className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-28"
      aria-labelledby="law-programmes-heading"
    >
      {/* Decorative elements */}
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
      >
        <div className="absolute -right-32 top-20 h-[480px] w-[480px] rounded-full border-[80px] border-[#8B1E3F]/[0.035]" />

        <div className="absolute -left-32 bottom-0 h-[400px] w-[400px] rounded-full bg-[#D5AD57]/10 blur-[100px]" />

        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#D5AD57] to-transparent" />

        <div className="absolute inset-0 opacity-[0.025] [background-image:linear-gradient(#071A2F_1px,transparent_1px),linear-gradient(90deg,#071A2F_1px,transparent_1px)] [background-size:56px_56px]" />
      </div>

      <div className="relative mx-auto max-w-[1380px] px-5 sm:px-8 lg:px-10">
        {/* Section heading */}
        <div className="grid gap-10 lg:grid-cols-[1.08fr_0.92fr] lg:items-end">
          <div>
            <div className="flex items-center gap-4">
              <span className="h-px w-12 bg-[#8B1E3F]" />

              <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                Academic legal pathways
              </span>
            </div>

            <h2
              id="law-programmes-heading"
              className="mt-6 max-w-4xl text-[clamp(42px,5.5vw,74px)] font-normal leading-[1.02] tracking-[-0.04em] text-[#071A2F]"
              style={{
                fontFamily:
                  '"Libre Caslon Display", Georgia, serif',
              }}
            >
              Study the law.
              <em className="block font-normal text-[#8B1E3F]">
                Strengthen justice.
              </em>
            </h2>
          </div>

          <div className="lg:pb-2">
            <p className="max-w-xl text-base leading-8 text-[#132337]/65 sm:text-lg">
              Explore programmes that develop legal reasoning,
              constitutional understanding, research capability,
              ethical judgement and professional advocacy.
            </p>

            <div className="mt-7 flex flex-wrap gap-8">
              <div className="border-l-4 border-[#D5AD57] pl-5">
                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-4xl font-normal text-[#071A2F]">
                  {programmes.length}
                </strong>

                <span className="ml-3 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F]/50">
                  Programmes
                </span>
              </div>

              <div className="border-l-4 border-[#8B1E3F] pl-5">
                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-4xl font-normal text-[#071A2F]">
                  {Math.max(levels.length - 1, 1)}
                </strong>

                <span className="ml-3 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F]/50">
                  Study levels
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Level filters */}
        <div className="mt-12 flex gap-3 overflow-x-auto border-y border-[#071A2F]/15 py-5">
          {levels.map((item) => {
            const isActive = item === level;

            const count =
              item === "All"
                ? programmes.length
                : programmes.filter(
                  (programme) => programme.level === item
                ).length;

            return (
              <button
                key={item}
                type="button"
                onClick={() => handleLevelChange(item)}
                className={`flex shrink-0 items-center gap-3 rounded-full px-5 py-3 text-sm font-bold transition duration-300 ${isActive
                  ? "bg-[#071A2F] text-white shadow-[0_12px_30px_rgba(7,26,47,0.18)]"
                  : "border border-[#071A2F]/15 bg-white text-[#071A2F] hover:border-[#8B1E3F]"
                  }`}
              >
                {item}

                <span
                  className={`flex h-7 min-w-7 items-center justify-center rounded-full px-2 ${isActive
                    ? "bg-[#D5AD57] text-[#071A2F]"
                    : "bg-[#F7F2E8] text-[#8B1E3F]"
                    }`}
                >
                  {count}
                </span>
              </button>
            );
          })}
        </div>

        {current ? (
          <div className="mt-10 grid gap-6 xl:grid-cols-[380px_1fr]">
            {/* Programme register */}
            <aside className="overflow-hidden rounded-[28px] border border-[#071A2F]/10 bg-white">
              <div className="bg-[#071A2F] p-6 text-white">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                    Programme register
                  </span>

                  <span className="rounded-full border border-white/15 px-3 py-1.5 text-sm text-white/65">
                    {visible.length} available
                  </span>
                </div>

                <p className="mt-4 text-base leading-7 text-white/60">
                  Select a legal programme to review its academic
                  brief and admission details.
                </p>
              </div>

              <div className="max-h-[590px] space-y-2 overflow-y-auto p-3">
                {visible.map((programme, index) => {
                  const programmeId =
                    programme.name || programme.title;

                  const currentId =
                    current.name || current.title;

                  const isSelected = programmeId === currentId;

                  return (
                    <button
                      key={programmeId || index}
                      type="button"
                      onClick={() => setActive(index)}
                      className={`group flex w-full items-start gap-4 rounded-[18px] border p-4 text-left transition duration-300 ${isSelected
                        ? "border-[#8B1E3F] bg-[#F4E8EC]"
                        : "border-transparent hover:border-[#D5AD57] hover:bg-[#F7F2E8]"
                        }`}
                    >
                      <span
                        className={`grid h-11 w-11 shrink-0 place-items-center rounded-full text-base font-bold ${isSelected
                          ? "bg-[#8B1E3F] text-white"
                          : "bg-[#071A2F] text-[#D5AD57]"
                          }`}
                      >
                        §
                      </span>

                      <span className="flex-1">
                        <span className="text-sm font-bold uppercase tracking-[0.1em] text-[#8B1E3F]">
                          Case {String(index + 1).padStart(2, "0")} ·{" "}
                          {shortLevel(programme.level)}
                        </span>

                        <strong className="mt-2 line-clamp-2 block text-base leading-6 text-[#071A2F]">
                          {programme.title}
                        </strong>
                      </span>

                      <span
                        className={`mt-3 h-2.5 w-2.5 shrink-0 rounded-full ${isSelected
                          ? "bg-[#8B1E3F]"
                          : "bg-[#071A2F]/15"
                          }`}
                      />
                    </button>
                  );
                })}
              </div>
            </aside>

            {/* Selected programme brief */}
            <article className="relative flex min-h-[650px] flex-col overflow-hidden rounded-[28px] border border-[#071A2F]/10 bg-white shadow-[0_25px_70px_rgba(7,26,47,0.09)]">
              <div className="grid border-b border-[#071A2F]/10 lg:grid-cols-[1fr_190px]">
                <div className="p-5 sm:p-6 lg:p-9">
                  <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                    Academic brief ·{" "}
                    {String(active + 1).padStart(3, "0")}
                  </span>

                  <h3
                    className="mt-7 max-w-3xl text-[clamp(34px,4.5vw,56px)] font-normal leading-[1.08] text-[#071A2F]"
                    style={{
                      fontFamily:
                        '"Libre Caslon Display", Georgia, serif',
                    }}
                  >
                    {current.title}
                  </h3>
                </div>

                <div className="flex min-h-40 items-center justify-center bg-[#8B1E3F]">
                  <span className="font-['Libre_Caslon_Display',Georgia,serif] text-8xl text-[#D5AD57]">
                    §
                  </span>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-7 sm:p-9 lg:p-12">
                <div>
                  <span className="text-sm font-bold uppercase tracking-[0.13em] text-[#8B1E3F]">
                    Programme proposition
                  </span>

                  <p className="mt-5 max-w-4xl text-base leading-8 text-[#132337]/65 sm:text-lg">
                    {cleanText(current.banner_description) ||
                      "Build legal reasoning, research, advocacy and ethical judgement through rigorous academic study and applied legal learning."}
                  </p>
                </div>

                <div className="mt-9 grid overflow-hidden border-y border-[#071A2F]/15 sm:grid-cols-3">
                  {[
                    ["Academic level", shortLevel(current.level)],
                    ["Study duration", current.duration],
                    ["Study mode", current.mode || "Full Time"],
                  ].map(([label, value], index) => (
                    <div
                      key={label}
                      className={`py-6 sm:px-6 ${index < 2
                        ? "border-b border-[#071A2F]/10 sm:border-b-0 sm:border-r"
                        : ""
                        }`}
                    >
                      <span className="text-sm font-bold uppercase tracking-[0.1em] text-[#8B1E3F]">
                        {label}
                      </span>

                      <strong className="mt-3 block text-base leading-7 text-[#071A2F]">
                        {value || "View programme"}
                      </strong>
                    </div>
                  ))}
                </div>

                {current.eligibility && (
                  <div className="mt-7 grid gap-4 bg-[#F7F2E8] p-4 sm:grid-cols-[150px_1fr] content-center">
                    <span className="text-sm font-bold uppercase tracking-[0.11em] text-[#8B1E3F] content-center">
                      Eligibility
                    </span>

                    <p className="text-sm leading-7 text-[#132337]/65">
                      {current.eligibility}
                    </p>
                  </div>
                )}

                <a
                  href={programmeHref(current, basePath)}
                  className="mt-4 inline-flex w-fit items-center gap-3 rounded-full bg-[#8B1E3F] px-7 py-4 text-base font-bold text-white transition duration-300 hover:-translate-y-1 hover:bg-[#071A2F]"
                >
                  Examine programme
                  <ArrowIcon />
                </a>
              </div>
            </article>
          </div>
        ) : (
          <div className="mt-10 flex min-h-[320px] items-center justify-center rounded-[28px] border border-[#071A2F]/10 bg-white p-8 text-center">
            <div>
              <span className="font-['Libre_Caslon_Display',Georgia,serif] text-6xl text-[#8B1E3F]">
                §
              </span>

              <h3 className="mt-5 text-3xl font-semibold text-[#071A2F]">
                No programmes found
              </h3>

              <button
                type="button"
                onClick={() => handleLevelChange("All")}
                className="mt-6 rounded-full bg-[#8B1E3F] px-7 py-3.5 text-sm font-bold text-white"
              >
                View all programmes
              </button>
            </div>
          </div>
        )}

        {/* Legal learning outcomes */}
        <div className="mt-12 grid overflow-hidden rounded-[24px] border border-[#071A2F]/10 bg-white sm:grid-cols-2 lg:grid-cols-4">
          {[
            "Legal reasoning",
            "Research and drafting",
            "Advocacy and communication",
            "Professional ethics",
          ].map((outcome, index) => (
            <div
              key={outcome}
              className={`min-h-[160px] p-6 ${index < 3
                ? "border-b border-[#071A2F]/10 lg:border-b-0 lg:border-r"
                : ""
                }`}
            >
              <span className="text-sm font-bold text-[#8B1E3F]">
                0{index + 1}
              </span>

              <h3 className="mt-5 text-xl font-semibold leading-8 text-[#071A2F]">
                {outcome}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// AcademicProgramsSections/PharmacyAcademicPrograms.js
function PharmacyAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const [active, setActive] = useState4(0);
  const current = programmes[active];
  return <section className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-32" aria-labelledby="pharmacy-programmes">
    <div className="absolute -right-28 top-20 h-96 w-96 rounded-full border-[70px] border-[#8B1E3F]/[0.04]" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <SectionIntro eyebrow="From formulation to care" title="Pharmaceutical" accent="learning pipeline." description="Progress from foundational science to formulation, quality, clinical understanding and responsible healthcare practice." />

      {current && <div className="mt-14 grid gap-8 lg:grid-cols-[1.15fr_0.85fr]">
        <div className="overflow-x-auto pb-3">
          <div className="relative flex min-w-[660px] items-start justify-between pt-4 before:absolute before:left-10 before:right-10 before:top-10 before:h-0.5 before:bg-[#071A2F]/10">
            {programmes.map((programme, index) => <button key={programme.name || programme.title} type="button" onClick={() => setActive(index)} className="group relative z-10 w-28 text-center">
              <span className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full border-4 border-[#F9F2F4] text-sm font-bold transition duration-300 ${active === index ? "scale-110 bg-[#8B1E3F] text-white shadow-[0_10px_30px_rgba(139,30,63,0.25)]" : "bg-white text-[#071A2F] group-hover:bg-[#D5AD57]"}`}>{String(index + 1).padStart(2, "0")}</span>
              <span className={`mt-4 block text-sm font-semibold leading-5 ${active === index ? "text-[#8B1E3F]" : "text-[#071A2F]/65"}`}>{shortLevel(programme.level)}</span>
            </button>)}
          </div>

          <article className="mt-10 rounded-[30px] border border-[#8B1E3F]/15 bg-white p-7 shadow-[0_24px_65px_rgba(7,26,47,0.08)] sm:p-9">
            <div className="flex flex-wrap items-center justify-between gap-4"><span className="rounded-full bg-[#071A2F] px-4 py-2 text-sm font-bold text-[#D5AD57]">Stage {String(active + 1).padStart(2, "0")}</span><span className="text-sm font-semibold text-[#8B1E3F]">{current.duration} · {current.mode}</span></div>
            <h3 className="mt-7 text-3xl font-semibold leading-tight text-[#071A2F] sm:text-4xl">{current.title}</h3>
            <p className="mt-5 text-base leading-8 text-[#132337]/65 sm:text-lg">{cleanText(current.banner_description) || "Develop scientific judgement through formulation studies, laboratory practice and patient-focused learning."}</p>
            <a href={programmeHref(current, basePath)} className="mt-7 inline-flex items-center gap-3 rounded-full bg-[#8B1E3F] px-6 py-3.5 text-base font-bold text-white transition hover:-translate-y-1">Explore programme <ArrowIcon /></a>
          </article>
        </div>

        <aside className="rounded-[30px] bg-[#071A2F] p-7 text-white sm:p-9">
          <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#D5AD57]">Programme prescription</span>
          <div className="mt-8 space-y-7">
            {[["01", "Entry requirement", current.eligibility], ["02", "Academic duration", current.duration], ["03", "Study framework", current.mode], ["04", "Professional focus", "Laboratory competence, quality and patient responsibility"]].map(([number, title, value]) => <div key={title} className="flex gap-4 border-b border-white/10 pb-6 last:border-0"><span className="text-sm font-bold text-[#D5AD57]">{number}</span><div><h4 className="text-base font-semibold">{title}</h4><p className="mt-2 text-sm leading-6 text-white/60">{value || "See programme details"}</p></div></div>)}
          </div>
        </aside>
      </div>}
    </div>
  </section>;
}

// AcademicProgramsSections/DesignAcademicPrograms.js
function DesignAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const [active, setActive] = useState5(0);
  const current = programmes[active];
  const tones = ["bg-[#8B1E3F]", "bg-[#071A2F]", "bg-[#D5AD57]", "bg-[#0C2744]"];
  return <section className="overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <div className="grid gap-10 lg:grid-cols-[0.82fr_1.18fr] lg:items-end"><div><span className="text-sm font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">Open studio · Academic programmes</span><h2 className="mt-6 text-[clamp(46px,6vw,78px)] font-normal leading-[0.98] tracking-[-0.05em] text-[#071A2F]" style={{ fontFamily: '"Libre Caslon Display", Georgia, serif' }}>Research.<br />Make. <em className="font-normal text-[#8B1E3F]">Refine.</em></h2></div><p className="max-w-xl text-base leading-8 text-[#132337]/65 sm:text-lg">Select a studio brief to see how each programme turns observation, experimentation and craft into purposeful design practice.</p></div>
      {current && <div className="mt-14 grid gap-5 lg:grid-cols-[340px_1fr]">
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-1 max-h-[560px] overflow-y-auto overflow-x-hidden custom-scroll pe-3">{programmes.map((programme, index) => <button key={programme.name || programme.title} type="button" onClick={() => setActive(index)} className={`group relative min-h-32 overflow-hidden rounded-[22px] p-5 text-left transition duration-300 ${active === index ? `${tones[index % tones.length]} translate-x-2 text-white shadow-[0_18px_45px_rgba(7,26,47,0.16)]` : "border border-[#071A2F]/10 bg-white text-[#071A2F] hover:-translate-y-1"}`}><div className="flex justify-between gap-3"><span className={`text-xs font-bold uppercase tracking-wider ${active === index ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}>{shortLevel(programme.level)}</span><span className="text-sm font-bold opacity-45">{String(index + 1).padStart(2, "0")}</span></div><strong className="mt-5 line-clamp-2 block text-lg leading-snug">{programme.title}</strong></button>)}</div>
        <article className="relative min-h-[560px] overflow-hidden rounded-[36px] bg-white p-7 shadow-[0_25px_75px_rgba(7,26,47,0.1)] sm:p-10 lg:p-14"><div className="absolute right-0 top-0 h-52 w-52 bg-[#D5AD57]/20 [clip-path:polygon(35%_0,100%_0,100%_100%,0_55%)]" /><div className="absolute bottom-0 right-0 h-44 w-44 bg-[#8B1E3F]/10 [clip-path:circle(50%_at_100%_100%)]" /><div className="relative flex h-full flex-col"><div className="flex items-center gap-3"><span className="h-3 w-3 rounded-full bg-[#8B1E3F]" /><span className="text-sm font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">Studio brief {String(active + 1).padStart(2, "0")}</span></div><h3 className="mt-9 max-w-4xl text-4xl font-normal leading-[1.08] text-[#071A2F] sm:text-5xl" style={{ fontFamily: '"Libre Caslon Display", Georgia, serif' }}>{current.title}</h3><p className="mt-7 max-w-3xl text-base leading-8 text-[#132337]/65 sm:text-lg">{cleanText(current.banner_description) || "Build an original creative practice through research, studio exploration, critique and portfolio development."}</p><div className="mt-10 grid gap-px overflow-hidden rounded-2xl bg-[#071A2F]/10 sm:grid-cols-3">{[["Format", current.mode], ["Duration", current.duration], ["Entry", current.eligibility]].map(([label, value]) => <div key={label} className="bg-[#F7F2E8] p-5"><span className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">{label}</span><strong className="mt-2 block text-sm leading-6 text-[#071A2F]">{value}</strong></div>)}</div><a href={programmeHref(current, basePath)} className="mt-auto inline-flex w-fit items-center gap-3 rounded-full bg-[#071A2F] px-6 py-3.5 text-base font-bold text-white transition hover:bg-[#8B1E3F]">Enter this studio <ArrowIcon /></a></div></article>
      </div>}
    </div>
  </section>;
}

// AcademicProgramsSections/EducationAcademicPrograms.js
function EducationAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const [active, setActive] = useState6(0);
  const current = programmes[active];
  return <section className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-32" aria-labelledby="education-programmes">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <SectionIntro eyebrow="The educator's journey" title="Learn to lead" accent="learning." description="Programmes that connect educational theory, classroom practice, inclusive pedagogy and reflective leadership." align="center" />

      {current && <div className="mt-14 grid gap-10 lg:grid-cols-[0.82fr_1.18fr]">
        <nav className="relative space-y-4 before:absolute before:bottom-8 before:left-11 before:top-8 before:w-px before:bg-[#8B1E3F]/20" aria-label="Education programme pathway">
          {programmes.map((programme, index) => <button key={programme.name || programme.title} type="button" onClick={() => setActive(index)} className={`relative flex w-full items-center gap-5 rounded-2xl border p-4 text-left transition duration-300 ${active === index ? "translate-x-2 border-[#8B1E3F] bg-white shadow-[0_18px_45px_rgba(7,26,47,0.08)]" : "border-transparent hover:bg-white/70"}`}>
            <span className={`relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full text-sm font-bold ${active === index ? "bg-[#8B1E3F] text-white" : "border border-[#8B1E3F]/20 bg-[#F7F2E8] text-[#8B1E3F]"}`}>{index + 1}</span>
            <span><small className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">{shortLevel(programme.level)}</small><strong className="mt-1 block text-lg leading-snug text-[#071A2F]">{programme.title}</strong></span>
          </button>)}
        </nav>

        <article className="relative overflow-hidden rounded-[32px] bg-white p-7 shadow-[0_25px_70px_rgba(7,26,47,0.1)] sm:p-10 lg:p-12">
          <div className="absolute right-0 top-0 h-40 w-40 rounded-bl-full bg-[#D5AD57]/15" aria-hidden="true" />
          <span className="relative inline-flex rounded-full bg-[#071A2F] px-4 py-2 text-sm font-bold text-[#D5AD57]">Pathway {String(active + 1).padStart(2, "0")}</span>
          <h3 className="relative mt-8 max-w-2xl text-3xl font-semibold leading-tight text-[#071A2F] sm:text-4xl">{current.title}</h3>
          <p className="relative mt-6 text-base leading-8 text-[#132337]/65 sm:text-lg">{cleanText(current.banner_description) || "Prepare for purposeful educational practice through theory, observation, mentoring and classroom experience."}</p>
          <div className="relative mt-9 grid gap-4 sm:grid-cols-3">{[["Practice", current.mode], ["Time", current.duration], ["Entry", current.eligibility]].map(([label, value]) => <div key={label} className="rounded-2xl bg-[#F7F2E8] p-5"><span className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">{label}</span><strong className="mt-2 block text-sm leading-6 text-[#071A2F]">{value}</strong></div>)}</div>
          <a href={programmeHref(current, basePath)} className="relative mt-8 inline-flex items-center gap-3 rounded-full bg-[#8B1E3F] px-6 py-3.5 text-base font-bold text-white transition hover:-translate-y-1">Follow this pathway <ArrowIcon /></a>
        </article>
      </div>}
    </div>
  </section>;
}

// AcademicProgramsSections/JournalismAcademicPrograms.js
function JournalismAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const [lead, setLead] = useState7(0);
  const current = programmes[lead];
  return <section className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-32" aria-labelledby="journalism-programmes">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <div className="border-y-4 border-[#071A2F] py-4"><div className="flex flex-wrap items-center justify-between gap-3"><span className="text-sm font-black uppercase tracking-[0.2em] text-[#8B1E3F]">The Academic Press</span><span className="text-sm font-semibold text-[#071A2F]/60">Newsroom edition · Programmes desk</span></div></div>
      <div className="mt-10"><SectionIntro eyebrow="Journalism & mass communication" title="Find your voice." accent="Report with purpose." description="Programmes for storytellers, reporters, media strategists and communication professionals who value accuracy, creativity and public impact." /></div>

      {current && <div className="mt-12 grid border-y border-[#071A2F]/20 lg:grid-cols-[1.25fr_0.75fr]">
        <article className="border-b border-[#071A2F]/20 py-8 lg:border-b-0 lg:border-r lg:pr-10">
          <div className="flex items-center gap-3"><span className="bg-[#8B1E3F] px-3 py-2 text-xs font-bold uppercase tracking-wider text-white">Lead programme</span><span className="text-sm font-semibold text-[#132337]/55">{shortLevel(current.level)} · {current.duration}</span></div>
          <h3 className="mt-7 max-w-3xl font-serif text-4xl font-bold leading-[1.05] text-[#071A2F] sm:text-5xl">{current.title}</h3>
          <p className="mt-6 max-w-3xl columns-1 text-base leading-8 text-[#132337]/65 sm:columns-2 sm:gap-8">{cleanText(current.banner_description) || "Learn to investigate, verify, create and communicate stories across contemporary media platforms."}</p>
          <div className="mt-8 flex flex-wrap items-center gap-4"><a href={programmeHref(current, basePath)} className="inline-flex items-center gap-3 bg-[#071A2F] px-6 py-3.5 text-base font-bold text-white">Read full programme <ArrowIcon /></a><span className="text-sm text-[#132337]/55">Eligibility: {current.eligibility}</span></div>
        </article>

        <aside className="py-8 lg:pl-10"><span className="text-sm font-black uppercase tracking-[0.16em] text-[#8B1E3F]">More from the programmes desk</span><div className="mt-5 divide-y divide-[#071A2F]/15">
          {programmes.map((programme, index) => <button key={programme.name || programme.title} type="button" onClick={() => setLead(index)} className={`group w-full py-5 text-left ${lead === index ? "opacity-100" : "opacity-65 hover:opacity-100"}`}><span className="flex items-start gap-4"><span className="font-serif text-xl font-bold text-[#8B1E3F]">{String(index + 1).padStart(2, "0")}</span><span><small className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">{shortLevel(programme.level)}</small><strong className="mt-1 block text-lg leading-snug text-[#071A2F] group-hover:underline">{programme.title}</strong><span className="mt-2 block text-sm text-[#132337]/50">{programme.duration}</span></span></span></button>)}
        </div></aside>
      </div>}

      <div className="mt-6 flex overflow-hidden bg-[#D5AD57] py-3 text-sm font-bold uppercase tracking-[0.12em] text-[#071A2F]"><div className="flex min-w-max gap-10 px-5">{["Reporting", "Digital media", "Broadcast", "Public relations", "Research", "Ethics", "Storytelling"].map((item) => <span key={item}>● {item}</span>)}</div></div>
    </div>
  </section>;
}

// AcademicProgramsSections/MediaEntertainmentAcademicPrograms.js
function MediaEntertainmentAcademicPrograms({
  courses,
  school,
  basePath = "/programmes",
}) {
  const programmes = getCourses(courses, school);

  const levels = useMemo(
    () => ["All", ...new Set(programmes.map((item) => item.level).filter(Boolean))],
    [programmes]
  );

  const [activeLevel, setActiveLevel] = useState("All");
  const [activeIndex, setActiveIndex] = useState(0);

  const visibleProgrammes = useMemo(
    () =>
      activeLevel === "All"
        ? programmes
        : programmes.filter((item) => item.level === activeLevel),
    [activeLevel, programmes]
  );

  const currentProgramme =
    visibleProgrammes[
    Math.min(activeIndex, Math.max(visibleProgrammes.length - 1, 0))
    ];

  const changeLevel = (level) => {
    setActiveLevel(level);
    setActiveIndex(0);
  };

  return (
    <section
      className="relative overflow-hidden bg-white py-20 sm:py-24 lg:py-28"
      aria-labelledby="media-programmes-heading"
    >
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-2 bg-gradient-to-r from-[#071A2F] via-[#8B1E3F] to-[#D5AD57]"
        aria-hidden="true"
      />

      <div
        className="pointer-events-none absolute right-0 top-0 h-full w-[42%] bg-[#F4E8EC]/60 [clip-path:polygon(32%_0,100%_0,100%_100%,0_100%)]"
        aria-hidden="true"
      />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="grid gap-8 lg:grid-cols-[1fr_400px] lg:items-end">
          <header>
            <div className="flex items-center gap-4">
              <span className="flex h-3 w-3 items-center justify-center rounded-full bg-[#8B1E3F]">
                <span className="h-1.5 w-1.5 rounded-full bg-white" />
              </span>

              <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                Media programme studio
              </span>
            </div>

            <h2
              id="media-programmes-heading"
              className="mt-6 text-[clamp(42px,5.5vw,72px)] font-normal leading-[1.02] tracking-[-0.04em] text-[#071A2F]"
              style={{ fontFamily: '"Libre Caslon Display", Georgia, serif' }}
            >
              Imagine. Produce.
              <em className="block font-normal text-[#8B1E3F]">
                Influence culture.
              </em>
            </h2>

            <p className="mt-6 max-w-3xl text-base leading-8 text-[#132337]/65 sm:text-lg">
              Discover programmes that combine storytelling, performance,
              production, digital platforms and the creative business of
              contemporary entertainment.
            </p>
          </header>

          <div className="rounded-[26px] border border-[#071A2F]/10 bg-[#F7F2E8] p-6">
            <div className="flex items-center justify-between">
              <div>
                <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                  Studio directory
                </span>
                <strong className="mt-2 block text-4xl text-[#071A2F]">
                  {programmes.length}
                </strong>
                <span className="text-sm text-[#132337]/55">
                  Creative programmes
                </span>
              </div>

              <div className="grid h-20 w-20 place-items-center rounded-full border border-[#D5AD57] bg-white">
                <span className="text-2xl text-[#8B1E3F]">▶</span>
              </div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="mt-10 flex gap-3 overflow-x-auto" role="tablist">
          {levels.map((level) => (
            <button
              key={level}
              type="button"
              role="tab"
              aria-selected={activeLevel === level}
              onClick={() => changeLevel(level)}
              className={`shrink-0 rounded-full border px-5 py-3 text-sm font-bold transition duration-300 ${activeLevel === level
                ? "border-[#8B1E3F] bg-[#8B1E3F] text-white"
                : "border-[#071A2F]/15 bg-white text-[#071A2F] hover:border-[#D5AD57]"
                }`}
            >
              {level}
            </button>
          ))}
        </div>

        {currentProgramme && (
          <div className="mt-8 overflow-hidden rounded-[32px] border border-[#071A2F]/10 bg-[#F7F2E8] shadow-[0_24px_70px_rgba(7,26,47,0.09)]">
            {/* Compact programme strip */}
            <div className="border-b border-[#071A2F]/10 bg-[#071A2F] p-4 sm:p-5">
              <div className="flex gap-3 overflow-x-auto pb-1 custom-scroll pb-4">
                {visibleProgrammes.map((programme, index) => (
                  <button
                    key={programme.name || programme.title}
                    type="button"
                    onClick={() => setActiveIndex(index)}
                    className={`group w-[235px] shrink-0 rounded-2xl border p-4 text-left transition duration-300 sm:w-[270px] ${activeIndex === index
                      ? "border-[#D5AD57] bg-[#D5AD57] text-[#071A2F]"
                      : "border-white/15 bg-white/[0.05] text-white hover:bg-white/[0.1]"
                      }`}
                  >
                    <span className="flex items-center justify-between">
                      <small
                        className={`text-xs font-bold uppercase tracking-wider ${activeIndex === index
                          ? "text-[#8B1E3F]"
                          : "text-[#D5AD57]"
                          }`}
                      >
                        Channel {String(index + 1).padStart(2, "0")}
                      </small>

                      <span
                        className={`h-2.5 w-2.5 rounded-full ${activeIndex === index
                          ? "bg-[#8B1E3F]"
                          : "bg-white/30"
                          }`}
                      />
                    </span>

                    <strong className="mt-4 line-clamp-2 block min-h-[48px] text-base leading-6">
                      {programme.title}
                    </strong>

                    <span
                      className={`mt-3 block text-sm ${activeIndex === index
                        ? "text-[#071A2F]/65"
                        : "text-white/50"
                        }`}
                    >
                      {shortLevel(programme.level)} · {programme.duration}
                    </span>
                  </button>
                ))}
              </div>
            </div>

            {/* Active programme display */}
            <article className="grid lg:grid-cols-[1fr_300px]">
              <div className="relative flex min-h-[430px] flex-col bg-white p-7 sm:p-10 lg:p-12">
                <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                  Now presenting · Channel{" "}
                  {String(activeIndex + 1).padStart(2, "0")}
                </span>

                <h3
                  className="mt-7 max-w-4xl text-4xl font-normal leading-[1.08] text-[#071A2F] sm:text-5xl"
                  style={{ fontFamily: '"Libre Caslon Display", Georgia, serif' }}
                >
                  {currentProgramme.title}
                </h3>

                <p className="mt-6 max-w-3xl line-clamp-4 text-base leading-8 text-[#132337]/65 sm:text-lg">
                  {cleanText(currentProgramme.banner_description) ||
                    "Develop creative, technical and professional capabilities through studio practice, live projects, production workflows and contemporary digital platforms."}
                </p>

                <div className="mt-8 flex flex-wrap gap-3">
                  {["Storytelling", "Production", "Digital platforms"].map(
                    (skill) => (
                      <span
                        key={skill}
                        className="rounded-full border border-[#071A2F]/10 bg-[#F7F2E8] px-4 py-2 text-sm font-semibold text-[#071A2F]"
                      >
                        {skill}
                      </span>
                    )
                  )}
                </div>

                <a
                  href={programmeHref(currentProgramme, basePath)}
                  className="mt-4 inline-flex w-fit items-center gap-3 rounded-full bg-[#8B1E3F] px-6 py-3.5 text-base font-bold text-white transition duration-300 hover:-translate-y-1 hover:bg-[#701832]"
                >
                  Explore programme
                  <ArrowIcon />
                </a>
              </div>

              <aside className="bg-[#F4E8EC] p-7 sm:p-9">
                <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                  Production details
                </span>

                <dl className="mt-7 divide-y divide-[#071A2F]/10">
                  {[
                    ["Programme level", shortLevel(currentProgramme.level)],
                    ["Duration", currentProgramme.duration],
                    ["Study mode", currentProgramme.mode],
                  ].map(([label, value]) => (
                    <div key={label} className="py-5 first:pt-0">
                      <dt className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">
                        {label}
                      </dt>
                      <dd className="mt-2 text-base font-semibold leading-6 text-[#071A2F]">
                        {value || "View details"}
                      </dd>
                    </div>
                  ))}
                </dl>

                <div className="mt-6 border-l-2 border-[#D5AD57] pl-5">
                  <span className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">
                    Eligibility
                  </span>
                  <p className="mt-2 text-sm leading-7 text-[#132337]/65">
                    {currentProgramme.eligibility ||
                      "Refer to programme details"}
                  </p>
                </div>
              </aside>
            </article>
          </div>
        )}
      </div>
    </section>
  );
}

// AcademicProgramsSections/LibraryScienceAcademicPrograms.js
function LibraryScienceAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const [active, setActive] = useState9(0);
  const current = programmes[active];
  return <section className="relative overflow-hidden bg-[#EEF4F8] py-20 sm:py-24 lg:py-32">
    <div className="absolute inset-y-0 left-1/2 w-px bg-[#071A2F]/5" />
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-end"><div><span className="text-sm font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">Knowledge architecture</span><h2 className="mt-6 text-[clamp(44px,6vw,74px)] font-normal leading-[1.02] tracking-[-0.04em] text-[#071A2F]" style={{ fontFamily: '"Libre Caslon Display", Georgia, serif' }}>Organise knowledge.<br /><em className="font-normal text-[#8B1E3F]">Expand access.</em></h2></div><p className="max-w-xl text-base leading-8 text-[#132337]/65 sm:text-lg">Prepare to manage physical, digital and research knowledge through programmes that connect information systems, users and institutions.</p></div>
      {current && <div className="mt-14 grid gap-6 lg:grid-cols-[1fr_1fr]">
        <div className="relative overflow-hidden rounded-[32px] bg-[#F7F2E8] p-6 sm:p-9"><div className="absolute inset-0 opacity-25 [background-image:linear-gradient(#071A2F_1px,transparent_1px),linear-gradient(90deg,#071A2F_1px,transparent_1px)] [background-size:72px_72px]" /><div className="relative grid grid-cols-1 gap-4">{programmes.map((programme, index) => <button key={programme.name || programme.title} type="button" onClick={() => setActive(index)} className={`group relative min-h-44 rounded-full border p-5 text-center transition duration-500 ${active === index ? "scale-105 border-[#8B1E3F] bg-[#8B1E3F] text-white shadow-[0_18px_45px_rgba(139,30,63,0.2)]" : "border-[#071A2F]/10 bg-white text-[#071A2F] hover:border-[#D5AD57]"}`}><span className={`text-xs font-bold uppercase tracking-wider ${active === index ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}>{shortLevel(programme.level)}</span><strong className="mt-4 line-clamp-3 block text-base leading-6">{programme.title}</strong><span className="mt-3 block text-sm opacity-50">Node {String(index + 1).padStart(2, "0")}</span></button>)}</div></div>
        <article className="flex min-h-[560px] flex-col rounded-[32px] border border-[#071A2F]/10 bg-[#071A2F] p-7 text-white sm:p-10 lg:p-12"><div className="flex items-center justify-between"><span className="text-sm font-bold uppercase tracking-[0.15em] text-[#D5AD57]">Metadata record</span><span className="font-serif text-5xl text-white/10">{String(active + 1).padStart(3, "0")}</span></div><h3 className="mt-9 text-4xl font-normal leading-[1.08] sm:text-5xl" style={{ fontFamily: '"Libre Caslon Display", Georgia, serif' }}>{current.title}</h3><p className="mt-6 text-base leading-8 text-white/60 sm:text-lg">{cleanText(current.banner_description) || "Build expertise in information organisation, digital resources, user services and knowledge management."}</p><dl className="mt-8 divide-y divide-white/12 border-y border-white/12">{[["Classification", shortLevel(current.level)], ["Publication cycle", current.duration], ["Access requirement", current.eligibility]].map(([label, value]) => <div key={label} className="grid gap-2 py-3 sm:grid-cols-[150px_1fr]"><dt className="text-xs font-bold uppercase tracking-wider text-[#D5AD57] content-center">{label}</dt><dd className="text-sm leading-6 text-white/75">{value}</dd></div>)}</dl><a href={programmeHref(current, basePath)} className="mt-6 inline-flex w-fit items-center gap-3 rounded-full bg-[#D5AD57] px-6 py-3.5 text-base font-bold text-[#071A2F]">Access full record <ArrowIcon /></a></article>
      </div>}
    </div>
  </section>;
}

// AcademicProgramsSections/YogaNaturopathyAcademicPrograms.js
function YogaNaturopathyAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const [active, setActive] = useState10(0);
  const current = programmes[active];
  return <section className="relative overflow-hidden bg-white py-20 sm:py-24 lg:py-32 bg-[#EEE5D3]" aria-labelledby="yoga-programmes">
    <div className="absolute left-1/2 top-1/2 h-[620px] w-[620px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#D5AD57]/10 before:absolute before:inset-20 before:rounded-full before:border before:border-[#8B1E3F]/10 after:absolute after:inset-40 after:rounded-full after:border after:border-[#071A2F]/10" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <SectionIntro eyebrow="Knowledge in balance" title="Programmes for" accent="whole-person wellbeing." description="Study traditional knowledge, evidence-informed wellness and responsible practice through a balanced academic journey." align="center" />
      {current && <div className="mt-14 grid items-center gap-10 lg:grid-cols-[0.72fr_1.28fr]">
        <div className="relative mx-auto aspect-square w-full max-w-[470px] rounded-full border border-[#D5AD57]/40 bg-[#F7F2E8] p-8 shadow-[0_25px_70px_rgba(7,26,47,0.08)]">
          <div className="flex h-full flex-col items-center justify-center rounded-full border border-[#8B1E3F]/20 bg-white p-8 text-center"><span className="text-sm font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">Selected pathway</span><strong className="mt-5 text-2xl leading-snug text-[#071A2F] sm:text-3xl">{current.title}</strong><p className="mt-4 text-sm leading-7 text-[#132337]/60">{current.duration} · {current.mode}</p><a href={programmeHref(current, basePath)} className="mt-6 inline-flex items-center gap-2 text-base font-bold text-[#8B1E3F]">Explore <ArrowIcon /></a></div>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">{programmes.map((programme, index) => <button key={programme.name || programme.title} type="button" onClick={() => setActive(index)} className={`group rounded-[24px] border p-6 text-left transition duration-300 ${active === index ? "border-[#8B1E3F] bg-[#8B1E3F] text-white shadow-[0_20px_50px_rgba(139,30,63,0.2)]" : "border-[#071A2F]/10 bg-white text-[#071A2F] hover:-translate-y-1 hover:border-[#D5AD57]"}`}><div className="flex items-start justify-between"><span className={`text-xs font-bold uppercase tracking-wider ${active === index ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}>{shortLevel(programme.level)}</span><span className={`flex h-9 w-9 items-center justify-center rounded-full ${active === index ? "bg-white/10" : "bg-[#F7F2E8]"}`}>{index + 1}</span></div><h3 className="mt-5 text-xl font-semibold leading-snug">{programme.title}</h3>{active === index && <p className="mt-4 line-clamp-3 text-sm leading-7 text-white/70">{cleanText(programme.banner_description)}</p>}</button>)}</div>
      </div>}
    </div>
  </section>;
}

// AcademicProgramsSections/LifeScienceAcademicPrograms.js
function LifeScienceAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const [active, setActive] = useState11(0);
  const current = programmes[active];
  return <section className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <div className="mx-auto max-w-4xl text-center"><span className="text-sm font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">From molecule to ecosystem</span><h2 className="mt-6 text-[clamp(44px,6vw,76px)] font-normal leading-[1.02] tracking-[-0.04em] text-[#071A2F]" style={{ fontFamily: '"Libre Caslon Display", Georgia, serif' }}>Trace the pathways of <em className="font-normal text-[#8B1E3F]">living systems.</em></h2><p className="mx-auto mt-6 max-w-2xl text-base leading-8 text-[#132337]/65 sm:text-lg">Explore programmes that investigate life through laboratory science, research, biotechnology and ecological understanding.</p></div>
      {current && <div className="relative mt-16 lg:px-20"><div className="absolute bottom-10 left-1/2 top-10 hidden w-px -translate-x-1/2 bg-[#8B1E3F]/20 lg:block" />{programmes.map((programme, index) => <button key={programme.name || programme.title} type="button" onClick={() => setActive(index)} className={`group relative mb-5 grid w-full gap-4 rounded-[24px] border p-5 text-left transition duration-300 last:mb-0 lg:w-[47%] ${index % 2 ? "lg:ml-auto" : ""} ${active === index ? "border-[#8B1E3F] bg-[#8B1E3F] text-white shadow-[0_20px_50px_rgba(139,30,63,0.2)]" : "border-[#071A2F]/10 bg-white text-[#071A2F] hover:-translate-y-1 hover:border-[#D5AD57]"}`}><span className={`absolute top-1/2 hidden h-4 w-4 -translate-y-1/2 rounded-full border-4 border-[#F7F2E8] bg-[#8B1E3F] lg:block ${index % 2 ? "-left-[7.6%]" : "-right-[7.6%]"}`} /><div className="flex items-start justify-between"><span className={`text-xs font-bold uppercase tracking-wider ${active === index ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}>Sequence {String(index + 1).padStart(2, "0")} · {shortLevel(programme.level)}</span><span className="text-sm opacity-45">{programme.duration}</span></div><strong className="text-xl leading-snug">{programme.title}</strong>{active === index && <div className="border-t border-white/15 pt-4"><p className="line-clamp-3 text-sm leading-7 text-white/70">{cleanText(programme.banner_description)}</p><a href={programmeHref(programme, basePath)} className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-[#D5AD57]">Investigate programme <ArrowIcon className="h-4 w-4" /></a></div>}</button>)}</div>}
    </div>
  </section>;
}

// AcademicProgramsSections/VocationalManagementAcademicPrograms.js
function VocationalManagementAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const [selected, setSelected] = useState12(0);
  const current = programmes[selected];
  return <section className="relative overflow-hidden bg-[#EEF4F8] py-20 sm:py-24 lg:py-32" aria-labelledby="vocational-programmes">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <div className="grid gap-10 lg:grid-cols-[0.78fr_1.22fr] lg:items-end"><SectionIntro eyebrow="Skills into careers" title="Choose a practical" accent="career route." description="Industry-aligned programmes designed around applied competence, workplace confidence and professional progression." /><div className="grid grid-cols-3 gap-3">{[["01", "Learn"], ["02", "Practise"], ["03", "Perform"]].map(([number, label]) => <div key={label} className="rounded-2xl bg-white p-4 text-center shadow-sm"><span className="block text-sm font-bold text-[#8B1E3F]">{number}</span><strong className="mt-1 block text-base text-[#071A2F]">{label}</strong></div>)}</div></div>

      {current && <div className="mt-14 grid gap-5 lg:grid-cols-[1fr_380px]">
        <div className="max-h-[650px] overflow-y-auto pe-4 custom-scroll"><div className="grid gap-4 sm:grid-cols-2">{programmes.map((programme, index) => <button key={programme.name || programme.title} type="button" onClick={() => setSelected(index)} className={`group relative overflow-hidden rounded-[24px] border p-6 text-left transition duration-300 ${selected === index ? "border-[#071A2F] bg-[#071A2F] text-white shadow-[0_20px_55px_rgba(7,26,47,0.18)]" : "border-[#071A2F]/10 bg-white text-[#071A2F] hover:-translate-y-1 hover:border-[#8B1E3F]"}`}><div className="flex items-start justify-between"><span className={`rounded-lg px-3 py-2 text-xs font-bold uppercase tracking-wider ${selected === index ? "bg-[#D5AD57] text-[#071A2F]" : "bg-[#F7F2E8] text-[#8B1E3F]"}`}>{shortLevel(programme.level)}</span><span className="text-sm font-bold opacity-45">Route {String(index + 1).padStart(2, "0")}</span></div><h3 className="mt-8 text-xl font-semibold leading-snug">{programme.title}</h3><div className={`mt-5 flex items-center justify-between border-t pt-4 text-sm ${selected === index ? "border-white/10 text-white/60" : "border-[#071A2F]/10 text-[#132337]/55"}`}><span>{programme.duration}</span><span className="transition group-hover:translate-x-1">→</span></div></button>)}</div></div>
        <aside className="lg:sticky lg:top-24 lg:self-start"><article className="rounded-[28px] bg-[#8B1E3F] p-7 text-white shadow-[0_25px_65px_rgba(139,30,63,0.22)] sm:p-8"><span className="text-sm font-bold uppercase tracking-[0.15em] text-[#D5AD57]">Your selected route</span><h3 className="mt-6 text-2xl font-semibold leading-snug">{current.title}</h3><p className="mt-5 text-sm leading-7 text-white/70">{cleanText(current.banner_description) || "Build practical expertise through applied learning and workplace-oriented assessment."}</p><dl className="mt-7 space-y-4 border-t border-white/15 pt-6">{[["Duration", current.duration], ["Delivery", current.mode], ["Eligibility", current.eligibility]].map(([label, value]) => <div key={label} className="flex justify-between gap-5"><dt className="text-sm text-white/55">{label}</dt><dd className="text-right text-sm font-semibold">{value}</dd></div>)}</dl><a href={programmeHref(current, basePath)} className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-[#D5AD57] px-6 py-3.5 text-base font-bold text-[#071A2F]">View career route <ArrowIcon /></a></article></aside>
      </div>}
    </div>
  </section>;
}

// AcademicProgramsSections/HealthAlliedAcademicPrograms.js
function HealthAlliedAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const [active, setActive] = useState13(0);
  const current = programmes[active];
  return <section className="relative overflow-hidden bg-white py-20 sm:py-24 lg:py-32" aria-labelledby="health-programmes">
    <div className="absolute inset-x-0 top-0 h-2 bg-gradient-to-r from-[#071A2F] via-[#8B1E3F] to-[#D5AD57]" aria-hidden="true" />
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <div className="grid gap-10 lg:grid-cols-[0.88fr_1.12fr] lg:items-end"><SectionIntro eyebrow="Clinical and allied pathways" title="Prepare for care with" accent="competence." description="Explore programmes that unite health science, practical training, ethical responsibility and patient-centred professional practice." /><div className="rounded-[24px] border border-[#071A2F]/10 bg-[#F7F2E8] p-6"><div className="flex items-center gap-4"><span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#8B1E3F] text-white before:absolute before:h-6 before:w-1 before:rounded before:bg-white after:absolute after:h-1 after:w-6 after:rounded after:bg-white" /><div><span className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">Programme portfolio</span><strong className="mt-1 block text-xl text-[#071A2F]">{programmes.length} clinical learning routes</strong></div></div></div></div>

      {current && <div className="mt-14 overflow-hidden rounded-[32px] border border-[#071A2F]/10 bg-[#F7F2E8] shadow-[0_25px_70px_rgba(7,26,47,0.09)]">
        <div className="grid lg:grid-cols-[360px_1fr]">
          <nav className="bg-[#071A2F] p-5 text-white sm:p-7 overflow-y-auto max-h-[700px] custom-scroll" aria-label="Health programmes">{programmes.map((programme, index) => <button key={programme.name || programme.title} type="button" onClick={() => setActive(index)} className={`mb-3 flex w-full items-center gap-4 rounded-2xl border p-4 text-left transition last:mb-0 ${active === index ? "border-[#D5AD57] bg-white/10" : "border-white/10 hover:bg-white/[0.06]"}`}><span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-sm font-bold ${active === index ? "bg-[#D5AD57] text-[#071A2F]" : "bg-white/10"}`}>{String(index + 1).padStart(2, "0")}</span><span><small className="text-xs font-bold uppercase tracking-wider text-[#D5AD57]">{shortLevel(programme.level)}</small><strong className="mt-1 line-clamp-2 block text-sm leading-5">{programme.title}</strong></span></button>)}</nav>
          <article className="p-7 sm:p-10 lg:p-12"><div className="flex flex-wrap items-center justify-between gap-4"><span className="rounded-full bg-[#8B1E3F]/10 px-4 py-2 text-sm font-bold text-[#8B1E3F]">Clinical pathway {String(active + 1).padStart(2, "0")}</span><span className="text-sm font-semibold text-[#132337]/55">{current.duration}</span></div><h3 className="mt-8 text-3xl font-semibold leading-tight text-[#071A2F] sm:text-4xl">{current.title}</h3><p className="mt-6 text-base leading-8 text-[#132337]/65 sm:text-lg">{cleanText(current.banner_description) || "Develop disciplined knowledge and practical capability for responsible participation in contemporary healthcare."}</p>
            <div className="mt-9 grid gap-4 sm:grid-cols-3">{[["Foundation", "Core health sciences"], ["Practice", current.mode || "Applied learning"], ["Readiness", "Ethics and patient care"]].map(([label, value], index) => <div key={label} className="relative rounded-2xl border border-[#071A2F]/10 bg-white p-5 before:absolute before:left-0 before:top-5 before:h-10 before:w-1 before:rounded-r before:bg-[#8B1E3F]"><span className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">0{index + 1} · {label}</span><strong className="mt-3 block text-sm leading-6 text-[#071A2F]">{value}</strong></div>)}</div><div className="mt-8 flex flex-wrap items-center gap-5"><a href={programmeHref(current, basePath)} className="inline-flex items-center gap-3 rounded-full bg-[#8B1E3F] px-6 py-3.5 text-base font-bold text-white">Review programme <ArrowIcon /></a><span className="text-sm text-[#132337]/55"><strong className="text-[#071A2F]">Eligibility:</strong> {current.eligibility}</span></div>
          </article>
        </div>
      </div>}
    </div>
  </section>;
}

// AcademicProgramsSections/ManagementAcademicPrograms.js
function ManagementAcademicPrograms({ courses, school, basePath = "/programmes" }) {
  const programmes = getCourses(courses, school);
  const levels = useMemo4(() => getLevels(programmes), [programmes]);
  const [level, setLevel] = useState14("All");
  const [active, setActive] = useState14(0);
  const visible = level === "All" ? programmes : programmes.filter((item) => item.level === level);
  const current = visible[Math.min(active, Math.max(visible.length - 1, 0))];
  return <section className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
      <div className="grid gap-10 lg:grid-cols-[1fr_auto] lg:items-end">
        <SectionIntro eyebrow="Management pathways" title="Learn to decide." accent="Prepare to lead." description="Choose a management pathway built around strategic thinking, commercial awareness, leadership and responsible enterprise." />
        <div className="flex flex-wrap gap-2 lg:max-w-md lg:justify-end">{levels.map((item) => <button key={item} type="button" onClick={() => {
          setLevel(item);
          setActive(0);
        }} className={`rounded-full px-5 py-3 text-sm font-bold transition ${level === item ? "bg-[#8B1E3F] text-white" : "border border-[#071A2F]/15 bg-white text-[#071A2F] hover:border-[#8B1E3F]"}`}>{item}</button>)}</div>
      </div>

      {current && <div className="mt-14 grid overflow-hidden rounded-[32px] border border-[#071A2F]/10 bg-white shadow-[0_25px_70px_rgba(7,26,47,0.1)] lg:grid-cols-[0.9fr_1.1fr]">
        <div className="border-b border-[#071A2F]/10 lg:border-b-0 lg:border-r"><div className="border-b border-[#071A2F]/10 bg-[#071A2F] px-6 py-5 text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">Leadership portfolio</div>{visible.map((programme, index) => <button key={programme.name || programme.title} type="button" onClick={() => setActive(index)} className={`group grid min-h-24 w-full grid-cols-[48px_1fr_auto] items-center gap-4 border-b border-[#071A2F]/10 px-5 text-left transition last:border-b-0 ${active === index ? "bg-[#F4E8EC]" : "hover:bg-[#F7F2E8]"}`}><span className="text-sm font-bold text-[#A77B2D]">{String(index + 1).padStart(2, "0")}</span><span><small className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">{shortLevel(programme.level)}</small><strong className="mt-1 block text-lg leading-snug text-[#071A2F]">{programme.title}</strong></span><span className={`transition ${active === index ? "translate-x-1 text-[#8B1E3F]" : "text-[#071A2F]/35"}`}>→</span></button>)}</div>
        <article className="relative flex min-h-[600px] flex-col bg-[#071A2F] p-7 text-white sm:p-10 lg:p-12"><div className="absolute right-0 top-0 h-full w-1/3 opacity-[0.06] [background-image:linear-gradient(90deg,white_1px,transparent_1px),linear-gradient(white_1px,transparent_1px)] [background-size:42px_42px]" /><div className="relative flex h-full flex-col"><div className="flex items-center justify-between"><span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">Executive brief</span><span className="font-serif text-5xl text-white/10">{String(active + 1).padStart(2, "0")}</span></div><h3 className="mt-10 text-4xl font-normal leading-[1.08] sm:text-5xl" style={{ fontFamily: '"Libre Caslon Display", Georgia, serif' }}>{current.title}</h3><p className="mt-7 text-base leading-8 text-white/65 sm:text-lg">{cleanText(current.banner_description) || "Develop strategic, analytical and leadership capability for contemporary organisations."}</p><div className="mt-9 grid border-t border-white/15 sm:grid-cols-2">{[["Duration", current.duration], ["Eligibility", current.eligibility]].map(([label, value]) => <div key={label} className="border-b border-white/15 py-6 sm:first:border-r sm:first:pr-6 sm:last:pl-6"><span className="text-xs font-bold uppercase tracking-wider text-[#D5AD57]">{label}</span><strong className="mt-3 block text-base leading-7">{value}</strong></div>)}</div><a href={programmeHref(current, basePath)} className="mt-auto inline-flex w-fit items-center gap-3 rounded-full bg-[#D5AD57] px-6 py-3.5 text-base font-bold text-[#071A2F]">View programme <ArrowIcon /></a></div></article>
      </div>}
    </div>
  </section>;
}

// AcademicProgramsSections/CommerceAcademicPrograms.js
function CommerceAcademicPrograms({
  courses,
  school,
  basePath = "/programmes",
}) {
  const programmes = getCourses(courses, school);

  const levels = useMemo5(
    () => getLevels(programmes),
    [programmes]
  );

  const [level, setLevel] = useState15("All");
  const [selectedProgramme, setSelectedProgramme] =
    useState15(0);

  const filteredProgrammes =
    level === "All"
      ? programmes
      : programmes.filter(
        (programme) => programme.level === level
      );

  const activeProgramme =
    filteredProgrammes[
    Math.min(
      selectedProgramme,
      Math.max(filteredProgrammes.length - 1, 0)
    )
    ];

  const handleLevelChange = (selectedLevel) => {
    setLevel(selectedLevel);
    setSelectedProgramme(0);
  };

  return (
    <section
      id="academic-programs"
      className="relative overflow-hidden bg-white py-20 sm:py-24 lg:py-28"
      aria-labelledby="commerce-programmes-heading"
    >
      {/* Decorative background */}
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
      >
        <div className="absolute -left-40 top-32 h-[460px] w-[460px] rounded-full bg-[#D5AD57]/10 blur-[100px]" />

        <div className="absolute -right-40 bottom-0 h-[500px] w-[500px] rounded-full border-[90px] border-[#8B1E3F]/[0.025]" />

        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#D5AD57] to-transparent" />
      </div>

      <div className="relative mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
        {/* Section heading */}
        <div id="commerce-programmes-heading">
          <SectionIntro
            eyebrow="Academic programmes"
            title="Choose an academic pathway with"
            accent="commercial relevance."
            description="Browse the complete School of Commerce portfolio by academic level and open any programme for detailed information."
          />
        </div>

        {/* Academic level filters */}
        <div className="mt-12 flex gap-2 overflow-x-auto border-b-2 border-[#071A2F] pb-0">
          {levels.map((item) => {
            const isActive = level === item;

            const count =
              item === "All"
                ? programmes.length
                : programmes.filter(
                  (programme) =>
                    programme.level === item
                ).length;

            return (
              <button
                key={item}
                type="button"
                onClick={() => handleLevelChange(item)}
                className={`min-h-14 shrink-0 border-x border-t px-5 text-sm font-bold transition duration-300 ${isActive
                    ? "border-[#071A2F] bg-[#071A2F] text-white"
                    : "border-[#071A2F]/20 bg-[#F7F2E8] text-[#071A2F] hover:bg-[#EEE5D3]"
                  }`}
              >
                {item}

                <span
                  className={`ml-3 ${isActive
                      ? "text-[#D5AD57]"
                      : "text-[#8B1E3F]"
                    }`}
                >
                  {count}
                </span>
              </button>
            );
          })}
        </div>

        {activeProgramme ? (
          <div className="grid border-x border-b border-[#071A2F]/20 lg:grid-cols-[0.85fr_1.15fr]">
            {/* Programme selection register */}
            <div className="max-h-[750px] overflow-y-auto custom-scroll border-b border-[#071A2F]/20 lg:border-b-0 lg:border-r">
              <div className="sticky top-0 z-10 flex items-center justify-between border-b border-[#071A2F]/15 bg-[#F7F2E8] px-5 py-4">
                <span className="text-sm font-bold uppercase tracking-[0.13em] text-[#8B1E3F]">
                  Programme register
                </span>

                <span className="text-sm font-semibold text-[#132337]/55">
                  {filteredProgrammes.length} available
                </span>
              </div>

              {filteredProgrammes.map(
                (programme, index) => {
                  const isActive =
                    index === selectedProgramme;

                  const programmeId =
                    programme.name ||
                    programme.title ||
                    index;

                  return (
                    <button
                      key={programmeId}
                      type="button"
                      onClick={() =>
                        setSelectedProgramme(index)
                      }
                      className={`group grid min-h-28 w-full grid-cols-[48px_1fr_auto] items-center gap-4 border-b border-[#071A2F]/15 px-5 py-5 text-left transition duration-300 ${isActive
                          ? "bg-[#F4E8EC] text-[#8B1E3F]"
                          : "bg-white text-[#071A2F] hover:bg-[#F7F2E8]"
                        }`}
                    >
                      <span
                        className={`text-sm font-extrabold ${isActive
                            ? "text-[#8B1E3F]"
                            : "text-[#A77B2D]"
                          }`}
                      >
                        {String(index + 1).padStart(
                          2,
                          "0"
                        )}
                      </span>

                      <span>
                        <strong
                          className="block text-xl font-normal leading-7"
                          style={{
                            fontFamily:
                              '"Libre Caslon Display", Georgia, serif',
                          }}
                        >
                          {programme.title}
                        </strong>

                        <span
                          className={`mt-2 block text-sm ${isActive
                              ? "text-[#8B1E3F]/70"
                              : "text-[#65717D]"
                            }`}
                        >
                          {shortLevel(programme.level)}
                          {programme.duration
                            ? ` · ${programme.duration}`
                            : ""}
                        </span>
                      </span>

                      <span
                        className={`grid h-11 w-11 place-items-center rounded-full border transition duration-300 ${isActive
                            ? "border-[#8B1E3F] bg-[#8B1E3F] text-white"
                            : "border-[#071A2F]/15 text-[#071A2F] group-hover:border-[#8B1E3F] group-hover:bg-[#8B1E3F] group-hover:text-white"
                          }`}
                      >
                        <ArrowIcon className="h-4 w-4" />
                      </span>
                    </button>
                  );
                }
              )}
            </div>

            {/* Active programme details */}
            <article className="relative min-h-[650px] overflow-hidden bg-[#071A2F] p-7 text-white sm:p-10 lg:p-12">
              {/* Grid pattern */}
              <div
                className="pointer-events-none absolute right-0 top-0 h-full w-1/3 opacity-[0.07] [background-image:linear-gradient(90deg,white_1px,transparent_1px),linear-gradient(white_1px,transparent_1px)] [background-size:40px_40px]"
                aria-hidden="true"
              />

              <div
                className="pointer-events-none absolute -bottom-28 -left-28 h-72 w-72 rounded-full bg-[#8B1E3F]/35 blur-[80px]"
                aria-hidden="true"
              />

              <div className="relative flex min-h-[550px] flex-col">
                <div className="flex items-start justify-between gap-5">
                  <span className="inline-flex items-center gap-3 text-sm font-extrabold uppercase tracking-[0.14em] text-[#D5AD57]">
                    <span className="h-2.5 w-2.5 rounded-full bg-[#D5AD57]" />

                    {shortLevel(activeProgramme.level)}
                  </span>

                  <span
                    className="text-5xl text-white/15"
                    style={{
                      fontFamily:
                        '"Libre Caslon Display", Georgia, serif',
                    }}
                  >
                    {String(
                      selectedProgramme + 1
                    ).padStart(2, "0")}
                  </span>
                </div>

                <h3
                  className="mt-10 max-w-4xl text-[clamp(38px,5vw,68px)] font-normal leading-[1.05]"
                  style={{
                    fontFamily:
                      '"Libre Caslon Display", Georgia, serif',
                  }}
                >
                  {activeProgramme.title}
                </h3>

                <p className="mt-7 max-w-3xl text-base leading-8 text-white/65">
                  {cleanText(
                    activeProgramme.banner_description
                  ) ||
                    "Develop contemporary expertise across accounting, finance, taxation, banking, entrepreneurship and global business."}
                </p>

                <dl className="mt-10 grid border-t border-white/20 sm:grid-cols-2">
                  <div className="border-b border-white/20 py-6 sm:border-r sm:px-6 sm:first:pl-0">
                    <dt className="text-sm font-bold uppercase tracking-[0.1em] text-[#D5AD57]">
                      Duration
                    </dt>

                    <dd className="mt-3 text-xl leading-8">
                      {activeProgramme.duration ||
                        "View programme details"}
                    </dd>
                  </div>

                  <div className="border-b border-white/20 py-6 sm:px-6">
                    <dt className="text-sm font-bold uppercase tracking-[0.1em] text-[#D5AD57]">
                      Study mode
                    </dt>

                    <dd className="mt-3 text-xl leading-8">
                      {activeProgramme.mode ||
                        "Full Time"}
                    </dd>
                  </div>
                </dl>

                {activeProgramme.eligibility && (
                  <div className="mt-6 border-l-4 border-[#8B1E3F] bg-white/[0.05] p-5">
                    <span className="text-sm font-bold uppercase tracking-[0.1em] text-[#D5AD57]">
                      Eligibility
                    </span>

                    <p className="mt-3 text-sm leading-7 text-white/70">
                      {activeProgramme.eligibility}
                    </p>
                  </div>
                )}

                <a
                  href={programmeHref(
                    activeProgramme,
                    basePath
                  )}
                  className="mt-auto inline-flex min-h-14 w-fit items-center gap-6 bg-[#D5AD57] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-[#071A2F] transition duration-300 hover:-translate-y-1 hover:bg-white"
                >
                  View programme
                  <ArrowIcon className="h-4 w-4" />
                </a>
              </div>
            </article>
          </div>
        ) : (
          <div className="flex min-h-[360px] flex-col items-center justify-center border-x border-b border-[#071A2F]/20 bg-[#F7F2E8] px-6 text-center">
            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-7xl text-[#8B1E3F]/25">
              ₹
            </span>

            <h3
              className="mt-5 text-3xl font-normal text-[#071A2F]"
              style={{
                fontFamily:
                  '"Libre Caslon Display", Georgia, serif',
              }}
            >
              No programmes are available.
            </h3>

            <p className="mt-3 text-sm leading-7 text-[#132337]/55">
              Select another academic level to explore the
              available commerce programmes.
            </p>

            <button
              type="button"
              onClick={() => handleLevelChange("All")}
              className="mt-6 bg-[#8B1E3F] px-7 py-3.5 text-sm font-bold text-white"
            >
              View all programmes
            </button>
          </div>
        )}

        {/* Commerce focus areas */}
        <div className="mt-10 grid border-y border-[#071A2F]/15 sm:grid-cols-2 lg:grid-cols-4">
          {[
            ["Accounting", "Financial reporting and analysis"],
            ["Finance", "Markets, investments and banking"],
            ["Taxation", "Compliance and fiscal understanding"],
            ["Enterprise", "Digital commerce and entrepreneurship"],
          ].map(([title, description], index) => (
            <div
              key={title}
              className={`py-7 sm:px-6 ${index < 3
                  ? "border-b border-[#071A2F]/10 lg:border-b-0 lg:border-r"
                  : ""
                }`}
            >
              <span className="text-sm font-bold text-[#8B1E3F]">
                0{index + 1}
              </span>

              <h3 className="mt-4 text-xl font-semibold text-[#071A2F]">
                {title}
              </h3>

              <p className="mt-3 text-sm leading-7 text-[#132337]/60">
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// AcademicProgramsSections/EngineeringAcademicPrograms.js
function EngineeringAcademicPrograms({
  courses,
  school,
  basePath = "/programmes",
}) {
  const programmes = getCourses(courses, school);

  const programmeLevels = useMemo5(
    () => getLevels(programmes),
    [programmes]
  );

  const [activeProgrammeLevel, setActiveProgrammeLevel] =
    useState16("All");
  const [programmeSearch, setProgrammeSearch] = useState16("");
  const [visibleCount, setVisibleCount] = useState16(6);

  const filteredProgrammes = useMemo5(() => {
    const searchTerm = programmeSearch.trim().toLowerCase();

    return programmes.filter((programme) => {
      const matchesLevel =
        activeProgrammeLevel === "All" ||
        programme.level === activeProgrammeLevel;

      const searchableContent = [
        programme.title,
        programme.name,
        programme.level,
        programme.duration,
        programme.mode,
        cleanText(programme.banner_description),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      const matchesSearch =
        !searchTerm || searchableContent.includes(searchTerm);

      return matchesLevel && matchesSearch;
    });
  }, [programmes, activeProgrammeLevel, programmeSearch]);

  const displayedProgrammes = filteredProgrammes.slice(0, visibleCount);

  const handleProgrammeLevelChange = (selectedLevel) => {
    setActiveProgrammeLevel(selectedLevel);
    setVisibleCount(6);
  };

  const getProgrammeCode = (programme) => {
    if (programme.degree) {
      return programme.degree;
    }

    const ignoredWords = ["of", "in", "and", "the"];

    return (programme.title || "Engineering")
      .split(/\s+/)
      .filter(
        (word) => !ignoredWords.includes(word.toLowerCase())
      )
      .slice(0, 3)
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase();
  };

  return (
    <section
      id="engineering-programmes"
      className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-28"
      aria-labelledby="engineering-programmes-heading"
    >
      {/* Decorative background */}
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
      >
        <div className="absolute -left-44 top-0 h-[520px] w-[520px] rounded-full bg-[#D5AD57]/15 blur-[120px]" />

        <div className="absolute -bottom-56 right-[-8%] h-[600px] w-[600px] rounded-full bg-[#8B1E3F]/5 blur-[130px]" />

        <div className="absolute inset-0 opacity-[0.025] [background-image:linear-gradient(#071A2F_1px,transparent_1px),linear-gradient(90deg,#071A2F_1px,transparent_1px)] [background-size:48px_48px]" />

        <svg
          viewBox="0 0 800 600"
          fill="none"
          className="absolute right-0 top-0 h-full w-1/2 text-[#071A2F] opacity-[0.035]"
        >
          <path
            d="M70 60v100h140l80 80h180l80-80h230M290 240v130l80 80h180M550 450v100M210 160v-100"
            stroke="currentColor"
            strokeWidth="2"
          />

          <circle cx="210" cy="160" r="7" fill="currentColor" />
          <circle cx="290" cy="240" r="7" fill="currentColor" />
          <circle cx="470" cy="240" r="7" fill="currentColor" />
          <circle cx="370" cy="450" r="7" fill="currentColor" />
          <circle cx="550" cy="450" r="7" fill="currentColor" />
        </svg>
      </div>

      <div className="relative mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-10">
        {/* Section heading */}
        <div className="grid gap-8 lg:grid-cols-[1fr_0.62fr] lg:items-end">
          <div>
            <div className="flex items-center gap-4">
              <span className="h-px w-10 bg-[#8B1E3F]" />

              <span className="text-sm font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">
                Academic programmes
              </span>
            </div>

            <h2
              id="engineering-programmes-heading"
              className="mt-6 max-w-4xl text-[clamp(42px,5vw,72px)] font-normal leading-[1.03] tracking-[-0.045em] text-[#071A2F]"
              style={{
                fontFamily:
                  '"Libre Caslon Display", Georgia, serif',
              }}
            >
              Choose the engineering path
              <span className="italic text-[#8B1E3F]">
                {" "}
                that shapes your future.
              </span>
            </h2>
          </div>

          <div className="lg:pb-2">
            <p className="text-base leading-8 text-[#132337]/65 sm:text-lg">
              Explore programmes designed around scientific
              foundations, engineering practice, modern technology
              and industry-oriented problem solving.
            </p>

            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-11 min-w-11 items-center justify-center rounded-full bg-[#071A2F] px-3 text-sm font-bold text-[#D5AD57]">
                {programmes.length}
              </span>

              <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#071A2F]/55">
                Programmes available
              </span>
            </div>
          </div>
        </div>

        {/* Programme interface */}
        <div className="mt-12 overflow-hidden rounded-[28px] border border-[#071A2F]/10 bg-white shadow-[0_25px_75px_rgba(7,26,47,0.09)]">
          {/* Filters and search */}
          <div className="flex flex-col gap-5 border-b border-[#071A2F]/10 p-5 sm:p-6 lg:flex-row lg:items-center lg:justify-between">
            <div
              className="flex gap-2 overflow-x-auto pb-1 lg:pb-0"
              role="tablist"
              aria-label="Filter engineering programmes"
            >
              {programmeLevels.map((level) => {
                const isActive =
                  activeProgrammeLevel === level;

                const levelCount =
                  level === "All"
                    ? programmes.length
                    : programmes.filter(
                      (programme) =>
                        programme.level === level
                    ).length;

                return (
                  <button
                    key={level}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    onClick={() =>
                      handleProgrammeLevelChange(level)
                    }
                    className={`group flex shrink-0 items-center gap-3 rounded-full px-5 py-3 text-sm font-bold transition duration-300 ${isActive
                      ? "bg-[#071A2F] text-white shadow-[0_10px_25px_rgba(7,26,47,0.16)]"
                      : "border border-[#071A2F]/10 bg-[#F7F2E8]/60 text-[#071A2F] hover:border-[#D5AD57] hover:bg-white"
                      }`}
                  >
                    {level}

                    <span
                      className={`flex h-7 min-w-7 items-center justify-center rounded-full px-2 text-xs ${isActive
                        ? "bg-[#D5AD57] text-[#071A2F]"
                        : "bg-[#071A2F]/[0.07] text-[#071A2F]/60"
                        }`}
                    >
                      {levelCount}
                    </span>
                  </button>
                );
              })}
            </div>

            <label className="relative block w-full lg:w-[310px]">
              <span className="sr-only">
                Search engineering programmes
              </span>

              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.7"
                className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-[#071A2F]/40"
                aria-hidden="true"
              >
                <circle cx="11" cy="11" r="7" />
                <path d="m16 16 4 4" />
              </svg>

              <input
                type="search"
                value={programmeSearch}
                onChange={(event) => {
                  setProgrammeSearch(event.target.value);
                  setVisibleCount(6);
                }}
                placeholder="Search programmes..."
                className="w-full rounded-full border border-[#071A2F]/10 bg-[#F7F2E8]/60 py-3.5 pl-12 pr-5 text-sm text-[#071A2F] outline-none transition placeholder:text-[#132337]/40 focus:border-[#8B1E3F] focus:bg-white focus:ring-4 focus:ring-[#8B1E3F]/10"
              />
            </label>
          </div>

          {/* Results information */}
          <div className="flex flex-col gap-3 border-b border-[#071A2F]/10 bg-[#071A2F] px-6 py-4 text-white sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-[#D5AD57] motion-reduce:animate-none" />

              <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                Programme explorer
              </span>
            </div>

            <span className="text-sm text-white/60">
              Showing {displayedProgrammes.length} of{" "}
              {filteredProgrammes.length} programmes
            </span>
          </div>

          {/* Programme grid */}
          {displayedProgrammes.length > 0 ? (
            <div className="grid md:grid-cols-2 xl:grid-cols-3">
              {displayedProgrammes.map(
                (programme, index) => (
                  <article
                    key={
                      programme.name ||
                      programme.title ||
                      index
                    }
                    className={`group relative flex min-h-[390px] flex-col overflow-hidden border-[#071A2F]/10 bg-white p-6 transition duration-500 hover:z-10 hover:bg-[#071A2F] hover:text-white hover:shadow-[0_28px_70px_rgba(7,26,47,0.20)] sm:p-7
                      ${index % 2 === 0
                        ? "md:border-r"
                        : ""
                      }
                      ${index <
                        displayedProgrammes.length - 2
                        ? "md:border-b"
                        : ""
                      }
                      ${index % 3 !== 2
                        ? "xl:border-r"
                        : "xl:border-r-0"
                      }
                      ${index <
                        displayedProgrammes.length - 3
                        ? "xl:border-b"
                        : "xl:border-b-0"
                      }`}
                  >
                    {/* Background number */}
                    <span
                      className="pointer-events-none absolute -right-2 -top-7 select-none text-[110px] font-normal leading-none text-[#071A2F]/[0.035] transition duration-500 group-hover:text-white/[0.04]"
                      style={{
                        fontFamily:
                          '"Libre Caslon Display", Georgia, serif',
                      }}
                    >
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <div className="relative flex items-start justify-between gap-5">
                      <span className="inline-flex min-h-12 min-w-12 items-center justify-center rounded-xl bg-[#071A2F] px-3 text-xs font-bold uppercase tracking-wider text-[#D5AD57] transition duration-300 group-hover:bg-[#D5AD57] group-hover:text-[#071A2F]">
                        {getProgrammeCode(programme)}
                      </span>

                      <span className="rounded-full border border-[#071A2F]/10 bg-[#F7F2E8] px-3 py-2 text-xs font-bold uppercase tracking-[0.12em] text-[#8B1E3F] transition duration-300 group-hover:border-white/15 group-hover:bg-white/10 group-hover:text-[#D5AD57]">
                        {shortLevel(programme.level)}
                      </span>
                    </div>

                    <div className="relative mt-7">
                      <h3
                        className="text-2xl font-normal leading-[1.2] text-[#071A2F] transition duration-300 group-hover:text-white"
                        style={{
                          fontFamily:
                            '"Libre Caslon Display", Georgia, serif',
                        }}
                      >
                        {programme.title}
                      </h3>

                      <p className="mt-4 line-clamp-3 text-sm leading-7 text-[#132337]/60 transition duration-300 group-hover:text-white/60">
                        {cleanText(
                          programme.banner_description
                        ) ||
                          "Develop engineering knowledge through academic foundations, practical learning, modern laboratories and industry-focused projects."}
                      </p>
                    </div>

                    {/* Programme details */}
                    <div className="relative mt-6 grid grid-cols-2 gap-3">
                      {[
                        [
                          "Duration",
                          programme.duration ||
                          "View details",
                        ],
                        [
                          "Study mode",
                          programme.mode || "Full Time",
                        ],
                      ].map(([label, value]) => (
                        <div
                          key={label}
                          className="rounded-xl border border-[#071A2F]/10 bg-[#F7F2E8]/70 p-4 transition duration-300 group-hover:border-white/10 group-hover:bg-white/[0.06]"
                        >
                          <span className="block text-xs font-bold uppercase tracking-[0.12em] text-[#8B1E3F] group-hover:text-[#D5AD57]">
                            {label}
                          </span>

                          <strong className="mt-2 block text-sm font-semibold leading-6 text-[#071A2F] group-hover:text-white">
                            {value}
                          </strong>
                        </div>
                      ))}
                    </div>

                    <div className="relative mt-auto flex items-center justify-between border-t border-[#071A2F]/10 pt-5 transition duration-300 group-hover:border-white/10">
                      <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#071A2F] transition group-hover:text-[#D5AD57]">
                        View programme
                      </span>

                      <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#071A2F]/10 text-[#071A2F] transition duration-300 group-hover:border-[#D5AD57] group-hover:bg-[#D5AD57] group-hover:text-[#071A2F]">
                        <ArrowIcon className="h-4 w-4 transition duration-300 group-hover:-rotate-45" />
                      </span>
                    </div>

                    <div className="absolute bottom-0 left-0 h-[3px] w-0 bg-gradient-to-r from-[#D5AD57] to-[#8B1E3F] transition-all duration-500 group-hover:w-full" />

                    <a
                      href={programmeHref(
                        programme,
                        basePath
                      )}
                      className="absolute inset-0 z-20"
                      aria-label={`View ${programme.title}`}
                    />
                  </article>
                )
              )}
            </div>
          ) : (
            <div className="flex min-h-[340px] flex-col items-center justify-center px-6 py-16 text-center">
              <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#071A2F] text-[#D5AD57]">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  className="h-6 w-6"
                  aria-hidden="true"
                >
                  <circle cx="11" cy="11" r="7" />

                  <path d="m16 16 4 4M8.5 8.5l5 5M13.5 8.5l-5 5" />
                </svg>
              </span>

              <h3
                className="mt-6 text-2xl font-normal text-[#071A2F]"
                style={{
                  fontFamily:
                    '"Libre Caslon Display", Georgia, serif',
                }}
              >
                No matching programmes found.
              </h3>

              <p className="mt-3 max-w-md text-sm leading-7 text-[#132337]/55">
                Try another programme level or use a
                different search term.
              </p>

              <button
                type="button"
                onClick={() => {
                  setProgrammeSearch("");
                  setActiveProgrammeLevel("All");
                  setVisibleCount(6);
                }}
                className="mt-6 rounded-full bg-[#8B1E3F] px-6 py-3 text-sm font-bold text-white transition hover:bg-[#071A2F]"
              >
                Clear filters
              </button>
            </div>
          )}
        </div>

        {/* Show more */}
        {visibleCount < filteredProgrammes.length && (
          <div className="mt-9 flex flex-col items-center">
            <button
              type="button"
              onClick={() =>
                setVisibleCount(
                  (currentValue) => currentValue + 6
                )
              }
              className="group inline-flex items-center gap-4 rounded-full bg-[#8B1E3F] px-8 py-4 text-sm font-bold text-white shadow-[0_16px_35px_rgba(139,30,63,0.2)] transition duration-300 hover:-translate-y-1 hover:bg-[#071A2F]"
            >
              Show more programmes

              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/15 transition duration-300 group-hover:translate-y-1">
                <ArrowIcon className="h-3.5 w-3.5 rotate-90" />
              </span>
            </button>

            <span className="mt-3 text-sm text-[#132337]/50">
              {filteredProgrammes.length - visibleCount} more
              programmes available
            </span>
          </div>
        )}

        {/* Admission guidance */}
        <div className="mt-12 flex flex-col gap-6 rounded-[24px] border border-[#071A2F]/10 bg-white/70 p-6 backdrop-blur-md sm:flex-row sm:items-center sm:justify-between sm:p-8">
          <div>
            <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
              Need programme guidance?
            </span>

            <p
              className="mt-2 text-2xl font-normal text-[#071A2F]"
              style={{
                fontFamily:
                  '"Libre Caslon Display", Georgia, serif',
              }}
            >
              Speak with our admissions team to find the
              right engineering pathway.
            </p>
          </div>

          <a
            href="/contact-us"
            className="inline-flex shrink-0 items-center justify-center gap-3 rounded-full bg-[#071A2F] px-7 py-4 text-sm font-bold text-white transition duration-300 hover:-translate-y-1 hover:bg-[#8B1E3F]"
          >
            Request guidance

            <ArrowIcon className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}

// AcademicProgramsSections/InformationTechnologyAcademicPrograms.js
function InformationTechnologyAcademicPrograms({
  courses,
  school,
  basePath = "/programmes",
}) {
  const programmes = getCourses(courses, school);

  const levels = useMemo7(
    () => getLevels(programmes),
    [programmes]
  );

  const [level, setLevel] = useState17("All");
  const [query, setQuery] = useState17("");
  const [visibleCount, setVisibleCount] = useState17(6);

  const filteredProgrammes = programmes.filter((programme) => {
    const matchesLevel =
      level === "All" || programme.level === level;

    const searchableContent = `
      ${programme.title || ""}
      ${cleanText(programme.banner_description) || ""}
    `.toLowerCase();

    const matchesQuery = searchableContent.includes(
      query.trim().toLowerCase()
    );

    return matchesLevel && matchesQuery;
  });

  const displayedProgrammes = filteredProgrammes.slice(
    0,
    visibleCount
  );

  const hasMore =
    visibleCount < filteredProgrammes.length;

  const handleLevelChange = (selectedLevel) => {
    setLevel(selectedLevel);
    setVisibleCount(6);
  };

  const handleSearchChange = (event) => {
    setQuery(event.target.value);
    setVisibleCount(6);
  };

  const handleShowMore = () => {
    setVisibleCount((currentCount) => currentCount + 6);
  };

  const handleShowLess = () => {
    setVisibleCount(6);

    document
      .getElementById("it-programmes-results")
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  };

  return (
    <section
      id="information-technology-programmes"
      className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-32"
      aria-labelledby="it-programmes-heading"
    >
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        {/* Section introduction */}
        <div className="grid gap-10 lg:grid-cols-[1fr_360px] lg:items-end">
          <SectionIntro
            eyebrow="Future-ready computing"
            title="Programmes for the"
            accent="digital future."
            description="Explore pathways across computer science, AI, data, cloud, software development, cybersecurity and emerging technologies."
          />

          <div className="grid grid-cols-2 overflow-hidden rounded-2xl border border-[#071A2F]/10 bg-white shadow-sm">
            <div className="border-r border-[#071A2F]/10 p-5">
              <strong className="block text-3xl text-[#071A2F]">
                {programmes.length}
              </strong>

              <span className="text-sm text-[#132337]/55">
                Programmes
              </span>
            </div>

            <div className="p-5">
              <strong className="block text-3xl text-[#8B1E3F]">
                {Math.max(levels.length - 1, 0)}
              </strong>

              <span className="text-sm text-[#132337]/55">
                Study levels
              </span>
            </div>
          </div>
        </div>

        {/* Filters and search */}
        <div className="mt-12 rounded-[26px] border border-[#071A2F]/10 bg-white/90 p-3 shadow-[0_20px_60px_rgba(7,26,47,0.08)]">
          <div className="flex flex-col gap-3 xl:flex-row xl:justify-between">
            <div className="flex gap-2 overflow-x-auto custom-scroll pb-3">
              {levels.map((item) => {
                const isActive = level === item;

                const levelCount =
                  item === "All"
                    ? programmes.length
                    : programmes.filter(
                      (programme) =>
                        programme.level === item
                    ).length;

                return (
                  <button
                    key={item}
                    type="button"
                    onClick={() =>
                      handleLevelChange(item)
                    }
                    className={`flex shrink-0 items-center gap-2 rounded-xl px-4 py-3 text-sm font-bold transition ${isActive
                      ? "bg-[#071A2F] text-white"
                      : "text-[#132337]/60 hover:bg-[#071A2F]/5 hover:text-[#071A2F]"
                      }`}
                  >
                    {item}

                    <span
                      className={`flex h-6 min-w-6 items-center justify-center rounded-full px-1.5 text-xs ${isActive
                        ? "bg-[#D5AD57] text-[#071A2F]"
                        : "bg-[#F7F2E8] text-[#8B1E3F]"
                        }`}
                    >
                      {levelCount}
                    </span>
                  </button>
                );
              })}
            </div>

            <label className="flex items-center gap-3 rounded-xl bg-[#F7F2E8] px-4 xl:w-80">
              <SearchIcon />

              <input
                value={query}
                onChange={handleSearchChange}
                type="search"
                placeholder="Search programmes"
                className="h-12 min-w-0 flex-1 bg-transparent text-sm text-[#071A2F] outline-none placeholder:text-[#132337]/45"
              />
            </label>
          </div>
        </div>

        {/* Results summary */}
        <div
          id="it-programmes-results"
          className="mt-9 flex flex-col gap-3 border-b border-[#071A2F]/15 pb-5 sm:flex-row sm:items-end sm:justify-between"
        >
          <div>
            <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
              Programme portfolio
            </span>

            <h3
              className="mt-2 text-2xl font-normal text-[#071A2F] sm:text-3xl"
              style={{
                fontFamily:
                  '"Libre Caslon Display", Georgia, serif',
              }}
            >
              {level === "All"
                ? "Explore all technology pathways."
                : `Explore ${level} pathways.`}
            </h3>
          </div>

          {filteredProgrammes.length > 0 && (
            <p
              className="text-sm font-semibold text-[#132337]/55"
              aria-live="polite"
            >
              Showing{" "}
              <strong className="text-[#071A2F]">
                {displayedProgrammes.length}
              </strong>{" "}
              of{" "}
              <strong className="text-[#071A2F]">
                {filteredProgrammes.length}
              </strong>{" "}
              programmes
            </p>
          )}
        </div>

        {/* Programme cards */}
        {displayedProgrammes.length > 0 ? (
          <>
            <div className="mt-7 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
              {displayedProgrammes.map(
                (programme, index) => (
                  <article
                    key={
                      programme.name ||
                      programme.title ||
                      index
                    }
                    className="group relative flex min-h-[360px] flex-col overflow-hidden rounded-[28px] border border-[#071A2F]/10 bg-white p-6 transition duration-500 hover:-translate-y-2 hover:border-[#D5AD57] hover:shadow-[0_24px_60px_rgba(7,26,47,0.12)]"
                  >
                    <span className="pointer-events-none absolute right-5 top-2 text-7xl font-bold text-[#071A2F]/[0.035]">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <div className="relative flex justify-between gap-4">
                      <span className="rounded-xl bg-[#071A2F] px-3 py-2 text-xs font-bold uppercase tracking-wider text-[#D5AD57]">
                        {shortLevel(programme.level)}
                      </span>

                      <a
                        href={programmeHref(
                          programme,
                          basePath
                        )}
                        className="flex h-11 w-11 items-center justify-center rounded-full border border-[#071A2F]/15 text-[#071A2F] transition duration-300 group-hover:border-[#8B1E3F] group-hover:bg-[#8B1E3F] group-hover:text-white"
                        aria-label={`View ${programme.title}`}
                      >
                        <ArrowIcon className="h-4 w-4" />
                      </a>
                    </div>

                    <h3 className="relative mt-7 text-2xl font-semibold leading-snug text-[#071A2F]">
                      {programme.title}
                    </h3>

                    <p className="relative mt-4 line-clamp-3 text-sm leading-7 text-[#132337]/60">
                      {cleanText(
                        programme.banner_description
                      ) ||
                        "Develop future-ready knowledge through applied learning, technical practice and industry-oriented education."}
                    </p>

                    <div className="relative mt-auto grid grid-cols-2 gap-4 border-t border-[#071A2F]/10 pt-5">
                      <div>
                        <span className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">
                          Duration
                        </span>

                        <strong className="mt-1 block text-sm leading-6 text-[#071A2F]">
                          {programme.duration ||
                            "View programme"}
                        </strong>
                      </div>

                      <div>
                        <span className="text-xs font-bold uppercase tracking-wider text-[#8B1E3F]">
                          Study mode
                        </span>

                        <strong className="mt-1 block text-sm leading-6 text-[#071A2F]">
                          {programme.mode || "Full Time"}
                        </strong>
                      </div>
                    </div>
                  </article>
                )
              )}
            </div>

            {/* Show more controls */}
            {filteredProgrammes.length > 6 && (
              <div className="mt-12 flex flex-col items-center">
                <p
                  className="text-sm font-semibold text-[#132337]/55"
                  aria-live="polite"
                >
                  Showing{" "}
                  <strong className="text-[#071A2F]">
                    {displayedProgrammes.length}
                  </strong>{" "}
                  of{" "}
                  <strong className="text-[#071A2F]">
                    {filteredProgrammes.length}
                  </strong>{" "}
                  programmes
                </p>

                {/* Progress indicator */}
                <div className="mt-4 h-1.5 w-full max-w-sm overflow-hidden rounded-full bg-[#071A2F]/10">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-[#8B1E3F] to-[#D5AD57] transition-all duration-500"
                    style={{
                      width: `${Math.min(
                        (displayedProgrammes.length /
                          filteredProgrammes.length) *
                        100,
                        100
                      )}%`,
                    }}
                  />
                </div>

                <div className="mt-6 flex flex-wrap justify-center gap-3">
                  {hasMore && (
                    <button
                      type="button"
                      onClick={handleShowMore}
                      className="inline-flex items-center gap-3 rounded-full bg-[#8B1E3F] px-7 py-4 text-sm font-bold text-white transition duration-300 hover:-translate-y-1 hover:bg-[#071A2F] hover:shadow-[0_15px_35px_rgba(7,26,47,0.18)]"
                    >
                      Show more programmes

                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        className="h-4 w-4"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m6 9 6 6 6-6"
                        />
                      </svg>
                    </button>
                  )}

                  {!hasMore &&
                    displayedProgrammes.length > 6 && (
                      <button
                        type="button"
                        onClick={handleShowLess}
                        className="inline-flex items-center gap-3 rounded-full border border-[#071A2F]/15 bg-white px-7 py-4 text-sm font-bold text-[#071A2F] transition duration-300 hover:border-[#8B1E3F] hover:text-[#8B1E3F]"
                      >
                        Show fewer programmes

                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          className="h-4 w-4"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m18 15-6-6-6 6"
                          />
                        </svg>
                      </button>
                    )}
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="mt-8 flex min-h-[340px] flex-col items-center justify-center rounded-[28px] border border-[#071A2F]/10 bg-white p-8 text-center">
            <span className="grid h-16 w-16 place-items-center rounded-full bg-[#071A2F] text-[#D5AD57]">
              <SearchIcon />
            </span>

            <h3
              className="mt-6 text-3xl font-normal text-[#071A2F]"
              style={{
                fontFamily:
                  '"Libre Caslon Display", Georgia, serif',
              }}
            >
              No programmes found.
            </h3>

            <p className="mt-3 max-w-md text-sm leading-7 text-[#132337]/55">
              Try another search term or select a different
              academic level.
            </p>

            <button
              type="button"
              onClick={() => {
                setLevel("All");
                setQuery("");
                setVisibleCount(6);
              }}
              className="mt-6 rounded-full bg-[#8B1E3F] px-7 py-3.5 text-sm font-bold text-white"
            >
              Reset programme filters
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

// AcademicProgramsSections/HotelManagementAcademicPrograms.js
function HotelManagementAcademicPrograms({
  courses,
  school,
  basePath = "/programmes",
}) {
  const programmes = getCourses(courses, school);

  const levels = useMemo8(
    () => getLevels(programmes),
    [programmes]
  );

  const [level, setLevel] = useState18("All");
  const [selectedProgrammeName, setSelectedProgrammeName] =
    useState18("");

  const visible =
    level === "All"
      ? programmes
      : programmes.filter((item) => item.level === level);

  const selectedProgramme =
    visible.find(
      (programme) =>
        (programme.name || programme.title) ===
        selectedProgrammeName
    ) ||
    visible[0] ||
    null;

  const handleLevelChange = (selectedLevel) => {
    setLevel(selectedLevel);
    setSelectedProgrammeName("");
  };

  const programmeBenefits = [
    "Practical hospitality training",
    "Guest experience management",
    "Culinary and operational exposure",
    "Industry-oriented learning",
  ];

  return (
    <section
      id="hotel-management-programmes"
      className="relative overflow-hidden bg-[#F7F2E8] py-20 sm:py-24 lg:py-28"
      aria-labelledby="hotel-programmes-heading"
    >
      {/* Decorative background */}
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
      >
        <div className="absolute -left-40 top-20 h-[520px] w-[520px] rounded-full bg-[#D5AD57]/15 blur-[100px]" />

        <div className="absolute -right-52 bottom-0 h-[580px] w-[580px] rounded-full border-[90px] border-[#8B1E3F]/[0.04]" />

        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#D5AD57] to-transparent" />

        <div className="absolute inset-0 opacity-[0.025] [background-image:linear-gradient(45deg,#071A2F_1px,transparent_1px)] [background-size:42px_42px]" />
      </div>

      <div className="relative mx-auto max-w-[1380px] px-5 sm:px-8 lg:px-10">
        {/* Section introduction */}
        <div className="grid gap-10 lg:grid-cols-[1.08fr_0.92fr] lg:items-end">
          <div>
            <div className="flex items-center gap-4">
              <span className="h-px w-12 bg-[#8B1E3F]" />

              <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                Hospitality pathways
              </span>
            </div>

            <h2
              id="hotel-programmes-heading"
              className="mt-6 max-w-4xl text-[clamp(42px,5.5vw,74px)] font-normal leading-[1.02] tracking-[-0.04em] text-[#071A2F]"
              style={{
                fontFamily:
                  '"Libre Caslon Display", Georgia, serif',
              }}
            >
              Learn the art, operations and
              <em className="block font-normal text-[#8B1E3F]">
                business of hospitality.
              </em>
            </h2>
          </div>

          <div className="lg:pb-2">
            <p className="max-w-xl text-base leading-8 text-[#132337]/65 sm:text-lg">
              Explore programmes combining hotel operations,
              culinary practice, guest experience, tourism,
              professional service and hospitality leadership.
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-5">
              <div className="border-l-4 border-[#D5AD57] pl-5">
                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-4xl font-normal text-[#071A2F]">
                  {programmes.length}
                </strong>

                <span className="ml-3 text-sm font-bold uppercase tracking-[0.12em] text-[#071A2F]/50">
                  Programmes
                </span>
              </div>

              <div className="border-l-4 border-[#8B1E3F] pl-5">
                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-4xl font-normal text-[#071A2F]">
                  {Math.max(levels.length - 1, 1)}
                </strong>

                <span className="ml-3 text-sm font-bold uppercase tracking-[0.12em] text-[#071A2F]/50">
                  Study levels
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Programme level filters */}
        <div className="mt-12 flex gap-2 overflow-x-auto border-y border-[#071A2F]/15 py-5">
          {levels.map((item) => {
            const isActive = level === item;

            const programmeCount =
              item === "All"
                ? programmes.length
                : programmes.filter(
                  (programme) => programme.level === item
                ).length;

            return (
              <button
                key={item}
                type="button"
                onClick={() => handleLevelChange(item)}
                className={`flex shrink-0 items-center gap-3 rounded-full px-5 py-3 text-sm font-bold transition duration-300 ${isActive
                  ? "bg-[#8B1E3F] text-white shadow-[0_12px_30px_rgba(139,30,63,0.18)]"
                  : "border border-[#071A2F]/15 bg-white text-[#071A2F] hover:border-[#D5AD57]"
                  }`}
              >
                {item}

                <span
                  className={`flex h-7 min-w-7 items-center justify-center rounded-full px-2 text-xs ${isActive
                    ? "bg-white/15 text-white"
                    : "bg-[#F7F2E8] text-[#8B1E3F]"
                    }`}
                >
                  {programmeCount}
                </span>
              </button>
            );
          })}
        </div>

        {selectedProgramme ? (
          <div className="mt-10 grid gap-6 lg:grid-cols-[0.88fr_1.12fr]">
            {/* Selected programme feature */}
            <article className="relative flex min-h-[650px] flex-col overflow-hidden rounded-[36px_8px_36px_8px] bg-[#071A2F] p-7 text-white sm:p-9 lg:sticky lg:top-28 lg:p-11">
              <div
                className="pointer-events-none absolute -right-28 -top-28 h-80 w-80 rounded-full border-[60px] border-[#D5AD57]/10"
                aria-hidden="true"
              />

              <div
                className="pointer-events-none absolute bottom-0 left-0 h-56 w-56 -translate-x-1/2 translate-y-1/2 rounded-full bg-[#8B1E3F]/40 blur-[70px]"
                aria-hidden="true"
              />

              <div className="relative flex items-center justify-between gap-5">
                <span className="inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/[0.05] px-5 py-3 text-sm font-bold uppercase tracking-[0.12em] text-[#D5AD57]">
                  <span className="h-2.5 w-2.5 rounded-full bg-[#D5AD57]" />

                  Featured pathway
                </span>

                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-5xl text-white/10">
                  01
                </span>
              </div>

              <div className="relative mt-12">
                <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                  {shortLevel(selectedProgramme.level)}
                </span>

                <h3
                  className="mt-5 text-[clamp(32px,4vw,50px)] font-normal leading-[1.08] text-white"
                  style={{
                    fontFamily:
                      '"Libre Caslon Display", Georgia, serif',
                  }}
                >
                  {selectedProgramme.title}
                </h3>

                <p className="mt-6 text-base leading-8 text-white/65">
                  {cleanText(
                    selectedProgramme.banner_description
                  ) ||
                    "Develop professional hospitality capabilities through operational learning, practical exposure and industry-relevant academic preparation."}
                </p>
              </div>

              {/* Programme information */}
              <div className="relative mt-9 grid gap-3 sm:grid-cols-2">
                <div className="border border-white/12 bg-white/[0.05] p-5">
                  <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#D5AD57]">
                    Duration
                  </span>

                  <strong className="mt-3 block text-lg font-semibold text-white">
                    {selectedProgramme.duration ||
                      "View programme"}
                  </strong>
                </div>

                <div className="border border-white/12 bg-white/[0.05] p-5">
                  <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#D5AD57]">
                    Study mode
                  </span>

                  <strong className="mt-3 block text-lg font-semibold text-white">
                    {selectedProgramme.mode || "Full Time"}
                  </strong>
                </div>
              </div>

              {selectedProgramme.eligibility && (
                <div className="relative mt-4 border-l-4 border-[#8B1E3F] bg-white/[0.05] p-5">
                  <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#D5AD57]">
                    Eligibility
                  </span>

                  <p className="mt-2 text-sm leading-7 text-white/65">
                    {selectedProgramme.eligibility}
                  </p>
                </div>
              )}

              <div className="relative mt-auto pt-10">
                <a
                  href={programmeHref(
                    selectedProgramme,
                    basePath
                  )}
                  className="inline-flex items-center gap-3 rounded-full bg-[#D5AD57] px-7 py-4 text-sm font-bold text-[#071A2F] transition duration-300 hover:-translate-y-1 hover:bg-white"
                >
                  View programme details

                  <ArrowIcon className="h-4 w-4" />
                </a>
              </div>
            </article>

            {/* Programme selection list */}
            <div className="space-y-4">
              <div className="flex flex-col gap-3 border-b border-[#071A2F]/15 pb-5 sm:flex-row sm:items-end sm:justify-between">
                <div>
                  <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                    Programme portfolio
                  </span>

                  <h3
                    className="mt-2 text-3xl font-normal text-[#071A2F]"
                    style={{
                      fontFamily:
                        '"Libre Caslon Display", Georgia, serif',
                    }}
                  >
                    Select your professional pathway.
                  </h3>
                </div>

                <span className="text-sm font-semibold text-[#132337]/50">
                  {visible.length} programmes available
                </span>
              </div>

              <div className="max-h-[850px] overflow-y-auto custom-scroll gap-4">
                {visible.map((programme, index) => {
                  const programmeId =
                    programme.name || programme.title;

                  const selectedId =
                    selectedProgramme.name ||
                    selectedProgramme.title;

                  const isSelected =
                    programmeId === selectedId;

                  return (
                    <article
                      key={programmeId || index}
                      className={`group relative overflow-hidden rounded-[8px_28px_8px_28px] border transition duration-500 mb-4 ${isSelected
                        ? "border-[#8B1E3F] bg-[#8B1E3F] text-white shadow-[0_20px_55px_rgba(139,30,63,0.16)]"
                        : "border-[#071A2F]/10 bg-white text-[#071A2F] hover:-translate-y-1 hover:border-[#D5AD57] hover:shadow-[0_18px_45px_rgba(7,26,47,0.08)]"
                        }`}
                    >
                      <button
                        type="button"
                        onClick={() =>
                          setSelectedProgrammeName(programmeId)
                        }
                        className="grid w-full gap-5 p-6 text-left sm:grid-cols-[74px_1fr_auto] sm:items-center sm:p-7"
                      >
                        <span
                          className={`flex h-16 w-16 items-center justify-center rounded-[6px_18px_6px_18px] text-lg font-bold ${isSelected
                            ? "bg-[#D5AD57] text-[#071A2F]"
                            : "bg-[#F7F2E8] text-[#8B1E3F]"
                            }`}
                        >
                          {String(index + 1).padStart(2, "0")}
                        </span>

                        <span>
                          <span
                            className={`text-sm font-bold uppercase tracking-[0.12em] ${isSelected
                              ? "text-[#D5AD57]"
                              : "text-[#8B1E3F]"
                              }`}
                          >
                            {shortLevel(programme.level)} ·{" "}
                            {programme.duration}
                          </span>

                          <strong
                            className="mt-3 block text-2xl font-normal leading-8"
                            style={{
                              fontFamily:
                                '"Libre Caslon Display", Georgia, serif',
                            }}
                          >
                            {programme.title}
                          </strong>

                          <span
                            className={`mt-3 block text-sm ${isSelected
                              ? "text-white/55"
                              : "text-[#132337]/50"
                              }`}
                          >
                            {programme.mode || "Full Time"}
                          </span>
                        </span>

                        <span
                          className={`grid h-12 w-12 place-items-center rounded-full border transition duration-300 ${isSelected
                            ? "border-white/20 text-[#D5AD57]"
                            : "border-[#071A2F]/15 text-[#071A2F] group-hover:border-[#8B1E3F] group-hover:bg-[#8B1E3F] group-hover:text-white"
                            }`}
                        >
                          <ArrowIcon
                            className={`h-4 w-4 transition duration-300 ${isSelected ? "-rotate-45" : ""
                              }`}
                          />
                        </span>
                      </button>

                      <span
                        className={`absolute inset-y-0 left-0 w-1 bg-[#D5AD57] transition ${isSelected
                          ? "scale-y-100"
                          : "scale-y-0 group-hover:scale-y-100"
                          }`}
                      />
                    </article>
                  );
                })}
              </div>
            </div>
          </div>
        ) : (
          <div className="mt-10 flex min-h-[340px] flex-col items-center justify-center rounded-[28px] border border-[#071A2F]/10 bg-white px-6 text-center">
            <span className="grid h-16 w-16 place-items-center rounded-full bg-[#071A2F] text-[#D5AD57]">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                className="h-6 w-6"
                aria-hidden="true"
              >
                <circle cx="11" cy="11" r="7" />
                <path d="m16 16 4 4" />
              </svg>
            </span>

            <h3
              className="mt-6 text-3xl font-normal text-[#071A2F]"
              style={{
                fontFamily:
                  '"Libre Caslon Display", Georgia, serif',
              }}
            >
              No programmes are available.
            </h3>

            <p className="mt-3 text-sm leading-7 text-[#132337]/55">
              Select another academic level to explore the
              available hospitality pathways.
            </p>

            <button
              type="button"
              onClick={() => handleLevelChange("All")}
              className="mt-6 rounded-full bg-[#8B1E3F] px-7 py-3.5 text-sm font-bold text-white"
            >
              View all programmes
            </button>
          </div>
        )}

        {/* Hospitality learning benefits */}
        <div className="mt-14 grid overflow-hidden rounded-[28px] border border-[#071A2F]/10 bg-white sm:grid-cols-2 lg:grid-cols-4">
          {programmeBenefits.map((benefit, index) => (
            <div
              key={benefit}
              className={`min-h-[170px] p-6 sm:p-7 ${index < programmeBenefits.length - 1
                ? "border-b border-[#071A2F]/10 lg:border-b-0 lg:border-r"
                : ""
                }`}
            >
              <span className="text-sm font-bold uppercase tracking-[0.13em] text-[#8B1E3F]">
                Benefit 0{index + 1}
              </span>

              <h3 className="mt-5 text-xl font-semibold leading-8 text-[#071A2F]">
                {benefit}
              </h3>
            </div>
          ))}
        </div>

        {/* Guidance CTA */}
        <div className="mt-10 grid overflow-hidden rounded-[8px_32px_8px_32px] border border-[#071A2F]/10 bg-white lg:grid-cols-[1fr_auto]">
          <div className="p-7 sm:p-9">
            <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
              Need programme guidance?
            </span>

            <h3
              className="mt-3 text-2xl font-normal leading-9 text-[#071A2F]"
              style={{
                fontFamily:
                  '"Libre Caslon Display", Georgia, serif',
              }}
            >
              Find the hospitality pathway that matches your
              professional ambition.
            </h3>
          </div>

          <a
            href="/contact-us"
            className="flex min-h-24 items-center justify-center gap-3 bg-[#071A2F] px-8 text-sm font-bold text-white transition duration-300 hover:bg-[#8B1E3F] lg:min-w-[260px]"
          >
            Speak to Admissions

            <ArrowIcon className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}

// AcademicProgramsSections/AcademicPrograms.js
var remainingSchoolComponents = {
  "school-of-management": ManagementAcademicPrograms,
  "school-of-commerce": CommerceAcademicPrograms,
  "school-of-engineering-and-technology": EngineeringAcademicPrograms,
  "school-of-information-and-technology": InformationTechnologyAcademicPrograms,
  "school-of-hotel-management": HotelManagementAcademicPrograms,
  "school-of-science": ScienceAcademicPrograms,
  "school-of-arts-and-humanities": ArtsHumanitiesAcademicPrograms,
  "school-of-law": LawAcademicPrograms,
  "school-of-pharmacy": PharmacyAcademicPrograms,
  "school-of-design": DesignAcademicPrograms,
  "school-of-education": EducationAcademicPrograms,
  "school-of-journalism-and-mass-communication": JournalismAcademicPrograms,
  "school-of-media-and-entertainment": MediaEntertainmentAcademicPrograms,
  "school-of-library-and-information-science": LibraryScienceAcademicPrograms,
  "school-of-yoga-and-naturopathy": YogaNaturopathyAcademicPrograms,
  "school-of-life-science": LifeScienceAcademicPrograms,
  "school-of-vocational-management": VocationalManagementAcademicPrograms,
  "school-of-vocational-studies": VocationalManagementAcademicPrograms,
  "school-of-health-and-allied-science": HealthAlliedAcademicPrograms
};
var normaliseSchoolId = (school) => school?.id || school?.school_name || school?.slug || "";
function UnsupportedAcademicPrograms({ schoolId }) {
  if (true) {
    console.warn(
      `[AcademicPrograms] No programme layout is registered for "${schoolId}".`
    );
  }
  return null;
}
function AcademicPrograms({
  school,
  courses,
  basePath = "/programmes",
  existingComponents = {}
}) {
  const schoolId = normaliseSchoolId(school);
  const ProgrammeSection = existingComponents[schoolId] || remainingSchoolComponents[schoolId];
  if (!ProgrammeSection) {
    return <UnsupportedAcademicPrograms schoolId={schoolId} />;
  }
  return <ProgrammeSection
    school={school}
    courses={courses || school?.courses || []}
    basePath={basePath}
  />;
}
export {
  AcademicPrograms,
  ArtsHumanitiesAcademicPrograms,
  CommerceAcademicPrograms,
  DesignAcademicPrograms,
  EducationAcademicPrograms,
  EngineeringAcademicPrograms,
  HealthAlliedAcademicPrograms,
  HotelManagementAcademicPrograms,
  InformationTechnologyAcademicPrograms,
  JournalismAcademicPrograms,
  LawAcademicPrograms,
  LibraryScienceAcademicPrograms,
  LifeScienceAcademicPrograms,
  ManagementAcademicPrograms,
  MediaEntertainmentAcademicPrograms,
  PharmacyAcademicPrograms,
  ScienceAcademicPrograms,
  UnsupportedAcademicPrograms,
  VocationalManagementAcademicPrograms,
  YogaNaturopathyAcademicPrograms,
  AcademicPrograms as default,
  remainingSchoolComponents
};
